<template>
<div>
    
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                   <div class="row breadcrumbs-top">
                      <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" > Admin Panel </h3>
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to='/mydashboard'>My Dashboard</router-link>
                                </li>
                                <li class="breadcrumb-item active">Admin Panel</li>
                                
                            </ol>
                        </div>
                        
                      </div>
                   </div>
                </div>
                
            </div>
            <div class="content-body">
                <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
                <section>
                     <div class="card">
                        <!-- <div class="card-header bg-white pt-1 px-1">
                            <h4 class="card-title">Masters</h4>
                            <div class="ml-auto d-flex">
                            
                             <div class="px-1 text-right mobile-padding-0-2" >
                                <div class="input-group-append float-right">
                                    <button id="commonaddmodule" class="btn btn-sm btn-relief-secondary" data-toggle="modal" aria-haspopup="true" aria-expanded="false" data-target="#addbutton"  type="button" data-backdrop="static" data-keyboard="false" @click="openAddForm"><span class="mobile_hide_bt"> Map Dock To Zone</span></button>
                                </div>
                            </div>
                          </div>
                        </div> -->
                        <div class="card-header px-0  common_top_title_searchbgst_dock">
                            <div class="container-fluid " >
                                <div class="row row fc_my-05">
                                    <div class="w-auto px-1 mobile-padding-0-2">
                                        <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                            <div class="avatar-content">
                                                
                                                <i data-feather='layers' class="i_icon_st la-clipboard-list las lab font-medium-3 "></i>
                                            </div>
                                        </div>
                                        <h4 class="card-title d-inline-flex ml-0 mb-0"> Admin Panel </h4>
                                    </div>
                                </div>    
                                    
                            </div>
                        </div>
                        <div class="card-body pt-1">
                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                    <label class="form-label text-left w-100">Search Panel</label>
                                    <treeselect :clearable="false" clear="false" placeholder="Search Type" v-model="searchPanelName" :options="searchPanelNameList" @select="handleSearchPanelNameList" />
                                </div>
                                <template v-if="searchPanelName === 'warehouse_master'">
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                    <label class="form-label text-left w-100">Warehouse</label>
                                    <treeselect  placeholder="Select Warehouse" v-model="search.warehouse_master.warehouse_id" :options="warehouseList" />
                                </div>
                                </template>
                                <template v-if="searchPanelName === 'vehicle_registration_master'">
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                        <label class="form-label text-left w-100">Vehicle Number</label>
                                        <treeselect  placeholder="Select Vehicle Number" v-model="search.vehicle_registration_master.vehicle_id" :options="vehicleList" />
                                    </div>
                                </template>
                                <template v-if="searchPanelName === 'gate_master'">
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                        <label class="form-label text-left w-100">Gate</label>
                                        <treeselect  placeholder="Select Gate Name" v-model="search.gate_master.gate_id" :options="gateList" />
                                    </div>
                                </template>
                                <template v-if="searchPanelName === 'dock_master'">
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                        <label class="form-label text-left w-100">Dock</label>
                                        <treeselect  placeholder="Select Dock Name" v-model="search.dock_master.dock_id" :options="dockList" />
                                    </div>
                                </template>
                                <template v-if="searchPanelName === 'zone_master'">
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                        <label class="form-label text-left w-100">Sector</label>
                                        <treeselect  placeholder="Select Sector Name" v-model="search.zone_master.zone_id" :options="zoneList" />
                                    </div>
                                </template>
                                <template v-if="searchPanelName === 'map_dock_to_sector'">
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                        <label class="form-label text-left w-100">Dock</label>
                                        <treeselect  placeholder="Select Dock Name" v-model="search.map_dock_to_sector.dock_id" :options="dockList" />
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                        <label class="form-label text-left w-100">Sector</label>
                                        <treeselect  placeholder="Select Sector Name" v-model="search.map_dock_to_sector.zone_id" :options="zoneList" />
                                    </div>
                                </template>
                                <template v-if="searchPanelName === 'ou_to_sector'">
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                        <label class="form-label text-left w-100">Zone</label>
                                        <treeselect  placeholder="Select Sector Name" v-model="search.ou_to_sector.zone_id" :options="zoneList" />
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                        <label class="form-label text-left w-100">OU</label>
                                        <treeselect  placeholder="Select OU Name" v-model="search.ou_to_sector.ou" :options="zoneList" />
                                    </div>
                                </template>
                                <template v-if="searchPanelName === 'vendor_master'">
                                    <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                                        <label class="form-label text-left w-100">Vendor</label>
                                        <treeselect  placeholder="Select Vendor Name" v-model="search.vendor_master.vendor_id" :options="vendorList" />
                                    </div>
                                </template>
                                <div class="col-12 col-sm-6 col-md-4 col-lg-4  text-left mb-1 home_das_all_buttons_style mobileview_b_8 ">
                                      <label class="w-100 d-block">&nbsp; </label>
                                    <button type="submit" class="btn btn-outline-primary mr-1 waves-effect  mr-1" @click="searchPanel(searchPanelName)">
                                        Search
                                    </button>
                                    <button type="submit" class="btn btn-outline-primary waves-effect mr-1" @click="searchReset">
                                        clear
                                    </button>
                                </div>
                            </div>
                        </div>
                      
                        <div class=" col-lg-12 px-0">
                            
                            <div class="card text-center mb-1">
                                <div class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0">
                                    <div class="nav-tabs epg-tabs subcategory-tabs no-bg scroll-both">
                                    
                                        <nav class="nav-tabs-wrapper main_divtabsview">
                                    <ul class="tabs_masters_detailstabing_pills  nav nav-pills   nav-pill-primary  pt-1 nav-tabs-items dragscroll">
                                        <li class="nav-item tabs-item active main_divtabsviewtoggle" data-day="1">
                                            <a class="nav-link active" id="warehouse_master_tab" data-toggle="tab" href="#warehouse_master" aria-expanded="true" @click="getWarehouseMaster">Warehouse
                                                <button class="btn  " @click="toggleMasterCreate"> 
                                                <i class="las la-plus mastercreateicon"></i> 
                                               </button>
                                            </a>
                                        </li>
                                        <li class="nav-item tabs-item  main_divtabsviewtoggle" data-day="3">
                                            <a class="nav-link" id="gate_master_tab" data-toggle="tab" href="#gate_master" aria-expanded="false" @click="getGateMaster">Gate
                                                <button class="btn btn-secondary " @click="toggleGatemaster"> 
                                                <i class="las la-plus mastercreateicon"></i> 
                                               </button>
                                            </a>
                                        </li>
                                        <li class="nav-item tabs-item  main_divtabsviewtoggle" data-day="4">
                                            <a class="nav-link" id="dock_master_tab" data-toggle="tab" href="#dock_master" aria-expanded="false" @click="getDockMaster">Dock
                                                <button class="btn btn-secondary " @click="toggleDockmaster"> 
                                                <i class="las la-plus mastercreateicon"></i> 
                                               </button>
                                            </a>
                                        </li>
                                        <li class="nav-item tabs-item  main_divtabsviewtoggle" data-day="5">
                                            <a class="nav-link" id="zone_master_tab" data-toggle="tab" href="#zone_master" aria-expanded="false" @click="getZoneMaster">Sector
                                                <button class="btn btn-secondary " @click="togglZoneMaster"> 
                                                <i class="las la-plus mastercreateicon"></i> 
                                               </button>
                                            </a>
                                        </li>
                                        <li class="nav-item tabs-item  main_divtabsviewtoggle" data-day="7">
                                            <a class="nav-link" id="zone_to_dock_mapping_tab" data-toggle="tab" href="#zone_to_dock_mapping" aria-expanded="false" @click="getZoneToDockMapping">Sector Dock Map
                                                <button class="btn btn-secondary " @click="toggledocMappingCreate"> 
                                                <i class="las la-plus mastercreateicon"></i> 
                                               </button>
                                            </a>
                                        </li>
                                        <li class="nav-item tabs-item  main_divtabsviewtoggle" data-day="6">
                                            <a class="nav-link" id="vendor_master_tab" data-toggle="tab" href="#vendor_master" aria-expanded="false" @click="getVendorMaster">Vendor
                                                <button class="btn btn-secondary " @click="togglVendorMaster"> 
                                                <i class="las la-plus mastercreateicon"></i> 
                                               </button>
                                            </a>
                                        </li>
                                        <li class="nav-item tabs-item  main_divtabsviewtoggle" data-day="2">
                                            <a class="nav-link" id="vehicle_registration_master_tab" data-toggle="tab" href="#vehicle_registration_master" aria-expanded="false" @click="getVehicleRegistrationMaster">Vehicles
                                                <button class="btn  " @click="togglevehicle_Registration"> 
                                                <i class="las la-plus mastercreateicon"></i> 
                                               </button>
                                            </a>
                                        </li>
                                        <li class="nav-item tabs-item  main_divtabsviewtoggle" data-day="2">
                                            <a class="nav-link" id="upload_tab" data-toggle="tab" href="#upload_master" aria-expanded="false">Upload
                                                <button class="btn  " @click="togglevehicle_Registration"> 
                                                    <i class="las la-upload mastercreateicon"></i> 
                                               </button>
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                                    <div class="nav-tabs-buttons">
                                        <i class="las la-angle-left nav-tabs-arrow nav-tabs-arrow-left material-icons"></i>
                                        <i class="las la-angle-right nav-tabs-arrow nav-tabs-arrow-right material-icons"></i>
                                        
                                    </div>
                                 </div>
                                    
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane active" id="warehouse_master" aria-labelledby="warehouse_master_tab" aria-expanded="true">
                                            
                                            <div class="container px-0" v-if="warehouse_master">
                                        <div class="row mx-0">
                                               
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Warehouse Name</label>
                                                    <input class="form-control" v-model="master.forms.warehouse_master.warehouse_name" type="text" placeholder="Enter Warehouse Name "/>
                                                    <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.warehouse_master.warehouse_name)">
                                                        Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">State</label>
                                                    <treeselect placeholder="Select State" v-model="master.forms.warehouse_master.state"  :options="stateList" @input="filterCityListStateWise"/>
                                                    <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.warehouse_master.state)">
                                                        Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">City</label>
                                                    <treeselect placeholder="Select City" v-model="master.forms.warehouse_master.city"  :options="cityListStateWise" />
                                                    <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.warehouse_master.city)">
                                                        Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Location</label>
                                                    <input class="form-control" v-model="master.forms.warehouse_master.location" type="text" placeholder="Enter Location  "/>
                                                    <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.warehouse_master.location)">
                                                        Required field
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Pin code</label>
                                                    <input class="form-control" v-model="master.forms.warehouse_master.pincode" type="text" placeholder="Enter Pin code  "/>
                                                    <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.warehouse_master.pincode)">
                                                        Required field
                                                    </div>
                                                    <div class="errorinputmsg text-left" v-if="getTrimmedString(master.forms.warehouse_master.pincode) && !validateInput('pincode', master.forms.warehouse_master.pincode)">
                                                        Invalid Pincode
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Latitude</label>
                                                    <input class="form-control" v-model="master.forms.warehouse_master.latitude" type="number" step="any" placeholder="Enter Latitude In Number"/>
                                                    <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.warehouse_master.latitude)">
                                                        Required field
                                                    </div> -->
                                                    <div class="errorinputmsg text-left" v-if="master.forms.warehouse_master.latitude && !validateInput('latitude', master.forms.warehouse_master.latitude)">
                                                        Invalid latitude
                                                    </div>
                                                </div>
                                                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                    <label class="form-label text-left w-100">Longitude</label>
                                                    <input class="form-control" v-model="master.forms.warehouse_master.longitude" type="text" placeholder="Enter Longitude in Number"/>
                                                    <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.warehouse_master.longitude)">
                                                        Required field
                                                    </div> -->
                                                    <div class="errorinputmsg text-left" v-if="master.forms.warehouse_master.longitude && !validateInput('longitude', master.forms.warehouse_master.longitude)">
                                                        Invalid longitude
                                                    </div>
                                                </div>
                                                <div class="pull-right text-right col-12 col-sm-6 col-md-6 col-lg-8  mb-1 common_trs_buttons_res">
                                                    
                                                    <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('warehouse_master')" @click="saveData('warehouse_master')" style="margin-top: 18px!important;">Submit</button> 
                                                </div>

                                            </div>
                                    </div>
                                        <div>
                                            <vue-element-loading :active="isMasterListLoading" />
                                            <div class="table-responsive datatableview">
                                                <table class="table table-striped table-hover table_stickys table-col-td-white custom_doctable ">
                                                    <thead>
                                                        <tr>
                                                            <!-- <th class="text-left align-middle">Warehouse id</th> -->
                                                            <th  class="text-left align-middle">Warehouse Name</th>
                                                            <th  class="text-left align-middle">City</th>
                                                            <th  class="text-left align-middle">Location</th>
                                                            <th  class="text-center align-middle">State</th>
                                                            <th  class="text-center align-middle">Pin code</th>
                                                            <th  class="text-center align-middle">Latitude</th>
                                                            <th  class="text-center align-middle">Longitude</th>
                                                            <th  class="text-center align-middle">Is Active</th>
                                                            <th  class="text-center align-middle">Created By</th>
                                                            <th  class="text-center align-middle">Created Date time</th>
                                                            <th  class="text-center align-middle">Warehouse Barcode </th>
                                                            <th  class="text-center align-middle">Manager id</th>
                                                            <th  class="text-left align-middle">Edit</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(data,index) in master.warehouse_master.list"  >
                                                            <tr>
                                                                <!-- <td data-column="Warehouse id"  class="text-left">
                                                                    <span class="font-weight-bold">{{data.warehouse_id}}</span>
                                                                </td> -->
                                                                <td  data-column="Warehouse Name" class="text-left">{{data.warehouse_name}}</td>
                                                                <td  data-column="City" class="text-left">{{data.city}}</td>
                                                                <td  data-column="Location" class="text-left">{{data.location}}</td>
                                                                <td  data-column="State" class="text-left">{{data.state}}</td>
                                                                <td  data-column=" Pin code" class="text-left">{{data.pincode}}</td>
                                                                <td  data-column="Latitude" class="text-left">{{data.latitude}}</td>
                                                                <td  data-column="Longitude" class="text-left">{{data.longitude}}</td>
                                                                <td  data-column="Is Active" class="text-left" v-if="data.is_active == 1"><span class="badge badge-pill badge-success mr-1">Active</span></td>
                                                                <td  data-column="Inactive" class="text-left" v-else><span class="badge badge-pill badge-light-danger mr-1">Inactive</span></td>
                                                                <td  data-column="Created By" class="text-left">{{convertEmailIdToName(data.created_by)}}</td>
                                                                <td  data-column="Created Date time" class="text-left">{{formatTimeStampToMonth(data.created_datetime)}}</td>
                                                                <td  data-column="Warehouse Barcode" class="text-left">{{data.warehouse_barcode}}</td>
                                                                <td  data-column="Manager id" class="text-left">{{data.manager_id}}</td>
                                                                <td data-column="Edit" class="text-center">
                                                                    <a @click="openEditForm('warehouse_master', data.warehouse_id)">
                                                                        <edit-icon></edit-icon>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                        <template v-if="!master.warehouse_master.list.length">
                                                            <tr><td colspan="14" style="text-align: center;">No records found</td></tr>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                <pagination v-model="master.warehouse_master.page" :records="master.warehouse_master.totalcount" :per-page="master.warehouse_master.pagelimit" @paginate="(e) => handlePageChange(e, 'warehouse_master')"/>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="tab-pane" id="vehicle_registration_master" role="tabpanel" aria-labelledby="vehicle_registration_master_tab" aria-expanded="false">
                                           <div class="container px-0" v-if="vehicle_registration_master">
                                                <div class="row mx-0">
                                                    
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vehicle Number</label>
                                                            <input class="form-control" v-model="master.forms.vehicle_registration_master.vehicle_number_plate" type="text" placeholder="Enter Vehicle Number "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vehicle_registration_master.vehicle_number_plate)">
                                                            Required field
                                                            </div>
                                                            <!-- <div class="errorinputmsg text-left" v-if="getTrimmedString(master.forms.vehicle_registration_master.vehicle_number_plate) && !validateInput('vehicle_number_plate')">
                                                            Invalid Vehicle Plate Number
                                                            </div> -->
                                                        </div>

                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vehicle Type</label>
                                                            <input class="form-control" v-model="master.forms.vehicle_registration_master.vehicle_type" type="text" placeholder="Enter Vehicle Type "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vehicle_registration_master.vehicle_type)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        

                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vehicle Size</label>
                                                            <input class="form-control" v-model="master.forms.vehicle_registration_master.vehicle_size" type="text" placeholder="Enter Vehicle Size  "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vehicle_registration_master.vehicle_size)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1" v-if="!isFormEdit">
                                                            <!-- sd -->
                                                            <label class="form-label text-left w-100">Vehicle Route Path </label>
                                                            <treeselect placeholder="Select Vehicle Route Paths" v-model="master.forms.vehicle_registration_master.route"  :options="routeList" multiple/>
                                                            <div class="errorinputmsg text-left" v-if="!master.forms.vehicle_registration_master.route || (master.forms.vehicle_registration_master.route && !master.forms.vehicle_registration_master.route.length)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1" v-else>
                                                            <label class="form-label text-left w-100">Vehicle Transation Type</label>
                                                            <treeselect placeholder="Select Vehicle Transation Type" v-model="master.forms.vehicle_registration_master.vehicle_transaction_type"  :options="vehicleTransactioTypeList" />
                                                            <!-- <div class="errorinputmsg text-left" v-if="!master.forms.vehicle_registration_master.vehicle_transaction_type">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vehicle Capacity (In Ton)</label>
                                                            <input class="form-control" v-model="master.forms.vehicle_registration_master.vehicle_tonnage" type="number" step="any" placeholder="Enter Vehicle Tonnage In Number "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vehicle_registration_master.vehicle_tonnage)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vendor</label>
                                                            <treeselect placeholder="Select Vendor" v-model="master.forms.vehicle_registration_master.vendor_id"  :options="vendorList" />
                                                            <div class="errorinputmsg text-left" v-if="!master.forms.vehicle_registration_master.vendor_id">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vehicle RC No.</label>
                                                            <input class="form-control" v-model="master.forms.vehicle_registration_master.vehicle_rc_no" type="text" placeholder="Enter Vehicle Size  "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vehicle_registration_master.vehicle_rc_no)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vehicle Documents</label>
                                                            <input class="form-control" v-model="master.forms.vehicle_registration_master.vehicle_documents" type="text" placeholder="Enter Vehicle Documents  "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vehicle_registration_master.vehicle_documents)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vehicle Condition</label>
                                                            <input class="form-control" v-model="master.forms.vehicle_registration_master.vehicle_condition" type="text" placeholder="Enter Vehicle Condition  "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vehicle_registration_master.vehicle_condition)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vehicle Attached To</label>
                                                            <input class="form-control" v-model="master.forms.vehicle_registration_master.vehicle_attached_to" type="text" placeholder="Enter Vehicle Attached To  "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vehicle_registration_master.vehicle_attached_to)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Last maintenance Date</label>
                                                            <date-picker placeholder="Select last maintenance date " v-model="master.forms.vehicle_registration_master.last_maintenance_date" valueType="format" @input="clearDate" class="startdate w-100"></date-picker>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!master.forms.vehicle_registration_master.last_maintenance_date">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Next maintenance due date</label>
                                                            <date-picker placeholder="Select Next maintenance due date " v-model="master.forms.vehicle_registration_master.next_maintenance_due_date" valueType="format" :disabled-date="disabledPastDates" class="startdate w-100"></date-picker>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!master.forms.vehicle_registration_master.next_maintenance_due_date">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Driver Name</label>
                                                            <input class="form-control" v-model="master.forms.vehicle_registration_master.vehicle_drivername" type="text" placeholder="Enter Driver Name  "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vehicle_registration_master.vehicle_drivername)">
                                                            Required field
                                                            </div>
                                                        </div>

                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Driver Mobile Number</label>
                                                            <input class="form-control" v-model="master.forms.vehicle_registration_master.driver_mobileno" type="text" placeholder="Enter Driver Mobile Number  "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vehicle_registration_master.driver_mobileno)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 plate_photoscan_mobile_mb-5">
                                                            <label class="form-label text-left w-100">RC Photo</label>
                                                            <div class="col-sm-12 plate_photoscan_mobile_canvasimage platesecondphoto mb-1">
                                                                <img alt=""  class="round img-fluid" src="../../public/images/icons/camera4.png">
                                                                <canvas id="rc-canvas" class="c" width=350 height=350></canvas>
                                                            </div>
                                                            <div class="col-sm-6 plate_photoscan_mobile">
                                                                <video id="rc-video" class="overlay-camera" autoplay @click="capturePhoto('rc')"></video>
                                                            </div>
                                                            <div class="col-sm-12 plate_photoscan_mobilebtn_mx-5 text-right px-0">
                                                                <button class="gateentyscan_camera_icon"  @click="turnOnCamera('rc')">
                                                                   <em class="las la-camera feather-camera"></em>
                                                                </button>
                                                                <audio id="rc-sound" :src="photoCaptureSound"></audio>
                                                            </div>
                                                        </div> 

                                                        <div class="pull-right text-right col-md-12 col-sm-12 col-xs-12  mb-1 common_trs_buttons_res">
                                                            <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('vehicle_registration_master')" @click="saveData('vehicle_registration_master')" style="margin-top: 10px!important;">Submit</button> 
                                                        </div>

                                                        

                                                    </div>
                                            </div>
                                            <div>
                                            <vue-element-loading :active="isMasterListLoading" />
                                                <div class="table-responsive datatableview">
                                                    <table class="table table-striped table-hover table_stickys table-col-td-white custom_doctable">
                                                        <thead>
                                                            <tr>
                                                                <!-- <th class="text-left align-middle">Vehicle id</th> -->
                                                                <th  class="text-left align-middle" style="width:220px;">Vehicle details</th>
                                                                <!-- <th  class="text-left align-middle">Vehicle Size</th>
                                                                <th  class="text-left align-middle"> Vehicle Tonnage</th> -->
                                                                <!-- <th  class="text-center align-middle">Vendor Name</th> -->
                                                                <th  class="text-left align-middle"> Vehicle Number details</th>
                                                                <!-- <th  class="text-center align-middle">Vehicle RC No</th> -->
                                                                <!-- <th  class="text-center align-middle">Vehicle Documents</th> -->
                                                                <th  class="text-center align-middle">Is active</th>
                                                                <!-- <th  class="text-center align-middle">Vehicle Condition</th>
                                                                <th  class="text-center align-middle">Vehicle Attached To</th> -->
                                                                <th  class="text-left align-middle" style="min-width:200px;">Created Details </th>
                                                                <!-- <th  class="text-center align-middle">Created Date time </th> -->
                                                                <!-- <th  class="text-center align-middle">Vehicle Barcode </th> -->
                                                                <th  class="text-left align-middle" style="min-width:200px;"> Maintenance details </th>
                                                                <!-- <th  class="text-center align-middle"> Next Maintenance Due Date </th> -->
                                                                <th  class="text-center align-middle"> Edit </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="(data,index) in master.vehicle_registration_master.list"  >
                                                                <tr>
                                                                    <!-- <td data-column="Vehicle id" class="text-left">
                                                                    
                                                                        <span class="font-weight-bold">{{data.vehicle_id}}</span>
                                                                    </td> -->
                                                                    <td data-column="Vehicle details"  class="text-left merge_column_detals">
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Vendor Name : </span>
                                                                            <span class="title_value_text"> {{data.vendor_id}}</span>
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Vehicle Type : </span>
                                                                            <span class="title_value_text"> {{data.vehicle_type}}</span>
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Vehicle Size : </span>
                                                                            <span class="title_value_text"> {{data.vehicle_size}} </span>
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Vehicle Tonnage : </span>
                                                                            <span class="title_value_text"> {{data.vehicle_tonnage}} </span>
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Vehicle Driver Name : </span>
                                                                            <span class="title_value_text"> {{data.vehicle_drivername}} </span>
                                                                        </div>
                                                                        
                                                                    </td>
                                                                    <!-- <td data-column="Vehicle Type" class="text-left">{{data.vehicle_type}}</td> -->
                                                                    <!-- <td data-column="Vehicle Size" class="text-left">{{data.vehicle_size}}</td> -->
                                                                    <!-- <td data-column="Vehicle Tonnage" class="text-left">{{data.vehicle_tonnage}}</td> -->
                                                                    <!-- <td data-column="Vendor id" class="text-left">{{data.vendor_id}}</td> -->

                                                                    <td data-column="Vehicle Number details"  class="text-left merge_column_detals">
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Number Plate : </span>
                                                                            <span class="title_value_text"> {{data.vehicle_number_plate}}</span>
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Vehicle RC No : </span>
                                                                            <span class="title_value_text">{{data.vehicle_rc_no}}</span>
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Vehicle Documents : </span>
                                                                            <span class="title_value_text"> {{data.vehicle_documents}} </span>
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Driver Mobile Number : </span>
                                                                            <span class="title_value_text"> {{data.driver_mobileno}} </span>
                                                                        </div>
                                                                    </td>
                                                                    <!-- <td data-column="Vehicle Number Plate" class="text-left">{{data.vehicle_number_plate}}</td>
                                                                    <td data-column="Vehicle RC No" class="text-left">{{data.vehicle_rc_no}}</td> -->
                                                                    <!-- <td data-column="Vehicle Documents" class="text-left">{{data.vehicle_documents}}</td> -->
                                                                    <td data-column="Is active" class="text-left" v-if="data.is_active == 1"><span class="badge badge-pill badge-success mr-1">Active</span></td>
                                                                    <td data-column="Inctive" class="text-left" v-else><span class="badge badge-pill badge-light-danger mr-1">Inactive</span></td>
                                                                    <!-- <td data-column="Vehicle Condition" class="text-left">{{data.vehicle_condition}}</td>
                                                                    <td data-column="Vehicle Attached To" class="text-left">{{data.vehicle_attached_to}}</td> -->
                                                                    
                                                                    <td data-column="Created Details"  class="text-left merge_column_detals">
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text">Created By : </span>
                                                                            <span class="title_value_text"> {{convertEmailIdToName(data.created_by)}}</span>
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text">Created Date time : </span> <br/>
                                                                            <span class="title_value_text"> {{formatTimeStampToMonth(data.created_datetime)}}</span>
                                                                        </div>
                                                                    </td>
                                                                    <!-- <td data-column="Created By" class="text-left">{{convertEmailIdToName(data.created_by)}}</td>
                                                                    <td data-column="Created Date time" class="text-left">{{formatTimeStampToMonth(data.created_datetime)}}</td> -->
                                                                    <!-- <td data-column="Vehicle Barcode" class="text-left">{{data.vehicle_barcode}}</td> -->
                                                                    <td data-column="Maintenance details"  class="text-left merge_column_detals">
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text"> Last Maintenance Date : </span>
                                                                            <span class="title_value_text"> {{data.last_maintenance_date}}</span>
                                                                        </div>
                                                                        <hr>
                                                                        <div class="meger_details"> 
                                                                            <span class="title_name_text">Next Maintenance Due Date: </span>
                                                                            <span class="title_value_text"> {{data.next_maintenance_due_date}}</span>
                                                                        </div>
                                                                    </td>
                                                                    <!-- <td data-column="Last Maintenance Date" class="text-left">{{data.last_maintenance_date}}</td>
                                                                    <td data-column="Next Maintenance Due Date" class="text-left">{{data.next_maintenance_due_date}}</td> -->
                                                                    <td  data-column="Edit"  >
                                                                        <a @click="openEditForm('vehicle_registration_master', data.vehicle_id)">
                                                                            <edit-icon></edit-icon>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-if="!master.vehicle_registration_master.list.length">
                                                                <tr><td colspan="14" style="text-align: center;">No records found</td></tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                    <pagination v-model="master.vehicle_registration_master.page" :records="master.vehicle_registration_master.totalcount" :per-page="master.vehicle_registration_master.pagelimit" @paginate="(e) => handlePageChange(e, 'vehicle_registration_master')"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="gate_master" role="tabpanel" aria-labelledby="gate_master_tab" aria-expanded="false">
                                            <div class="container px-0" v-if="gate_master">
                                                <div class="row mx-0">
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Gate Name</label>
                                                            <input class="form-control" v-model="master.forms.gate_master.gate_name" type="text" placeholder="Enter Gate Name "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.gate_master.gate_name)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Gate Type</label>
                                                            <treeselect placeholder="Select Gate Type" v-model="master.forms.gate_master.gate_type" :options="gateTypeList" />
                                                            <div class="errorinputmsg text-left" v-if="!master.forms.gate_master.gate_type">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Operational Hours</label>
                                                            <input class="form-control" v-model="master.forms.gate_master.operational_hours" type="text" placeholder="e.g., Mon-Sat 07:00 AM - 5:00 PM"/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.gate_master.operational_hours)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Usage Type</label>
                                                            <input class="form-control" v-model="master.forms.gate_master.usage_type" type="text" placeholder="Enter Usage Type"/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.gate_master.usage_type)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="pull-right text-right col-12 col-sm-6 col-md-6 col-lg-8  mb-1 common_trs_buttons_res">
                                                            <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('gate_master')" @click="saveData('gate_master')" style="margin-top: 18px!important;">Submit</button> 
                                                        </div>

                                                    </div>
                                            </div>  
                                            <div>
                                                <vue-element-loading :active="isMasterListLoading" />
                                                <div class="table-responsive datatableview">
                                                    <table class="table table-striped table-hover table_stickys table-col-td-white custom_doctable">
                                                        <thead>
                                                            <tr>
                                                                <!-- <th class="text-left align-middle">Gate id</th> -->
                                                                <th  class="text-left align-middle">Gate Name</th>
                                                                <th  class="text-left align-middle"> Gate Type</th>
                                                                <th  class="text-left align-middle">Is Active</th>
                                                                <th  class="text-center align-middle" > Created By</th>
                                                                <th  class="text-center align-middle"> Created Date Time</th>
                                                                <th  class="text-center align-middle">Gate Barcode </th>
                                                                <th  class="text-center align-middle">Operational Hours</th>
                                                                <th  class="text-center align-middle">Usage Type</th>
                                                                <th  class="text-center align-middle">Edit</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="(data,index) in master.gate_master.list"  >
                                                                <tr>
                                                                    <!-- <td data-column="Gate id" class="text-left">
                                                                    
                                                                        <span class="font-weight-bold">{{data.gate_id}}</span>
                                                                    </td> -->
                                                                    <td data-column="Gate Name" class="text-left">{{data.gate_name}}</td>
                                                                    <td data-column="Gate Type" class="text-left">{{data.gate_type}}</td>
                                                                    <td data-column="Is Active" class="text-left" v-if="data.is_active == 1"><span class="badge badge-pill badge-success mr-1">Active</span></td>
                                                                    <td data-column="InActive" class="text-left" v-else><span class="badge badge-pill badge-light-danger mr-1">Inactive</span></td>
                                                                    <td data-column="Created By" class="text-left">{{convertEmailIdToName(data.created_by)}}</td>
                                                                    <td data-column="Created Date Time" class="text-left">{{formatTimeStampToMonth(data.created_datetime)}}</td>
                                                                    <td data-column="Gate Barcode" class="text-left">{{data.gate_barcode}}</td>
                                                                    <td data-column="Operational Hours"  class="text-left">{{data.operational_hours}}</td>
                                                                    <td data-column="Usage Type"  class="text-left">{{data.usage_type}}</td>
                                                                    <td data-column="Edit" class="text-center">
                                                                        <a @click="openEditForm('gate_master', data.gate_id)">
                                                                            <edit-icon></edit-icon>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-if="!master.gate_master.list.length">
                                                                <tr><td colspan="14" style="text-align: center;">No records found</td></tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                    <pagination v-model="master.gate_master.page" :records="master.gate_master.totalcount" :per-page="master.gate_master.pagelimit" @paginate="(e) => handlePageChange(e, 'gate_master')"/>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="tab-pane" id="dock_master" role="tabpanel" aria-labelledby="dock_master_tab" aria-expanded="false">
                                            <div class="container px-0" v-if="dock_master">
                                                <div class="row mx-0">
                                                    
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Dock Name</label>
                                                            <input class="form-control" type="text" v-model="master.forms.dock_master.dock_name" placeholder="Enter Dock Name "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.dock_master.dock_name)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Dock Type</label>
                                                            <treeselect placeholder="Select Dock Type" v-model="master.forms.dock_master.dock_type" :options="gateTypeList" />
                                                            <div class="errorinputmsg text-left" v-if="!master.forms.dock_master.dock_type">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Dock Number</label>
                                                            <input class="form-control" v-model="master.forms.dock_master.dock_number"  type="text" placeholder="Enter Dock number "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.dock_master.dock_number)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Warehouse</label>
                                                            <treeselect placeholder="Select Warehouse" v-model="master.forms.dock_master.warehouse_id"  :options="warehouseList" />
                                                            <div class="errorinputmsg text-left" v-if="!master.forms.dock_master.warehouse_id">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Dock Location</label>
                                                            <input class="form-control" type="text" v-model="master.forms.dock_master.dock_location"  placeholder="Enter Dock Location "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.dock_master.dock_location)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Max Capacity</label>
                                                            <input class="form-control" type="number" step="1" v-model="master.forms.dock_master.max_capacity" placeholder="Enter Max Capacity In Number " />
                                                            <!-- <div class="errorinputmsg text-left" v-if="!master.forms.dock_master.max_capacity">
                                                            Required field
                                                            </div> -->
                                                            <div class="errorinputmsg text-left" v-if="master.forms.dock_master.max_capacity && !validateInput('whole_number', master.forms.dock_master.max_capacity)">
                                                            Invalid Max Capacity
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Current Usage</label>
                                                            <input class="form-control" type="number" v-model="master.forms.dock_master.current_usage" placeholder="Enter Max Usage In Number "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!master.forms.dock_master.current_usage">
                                                            Required field
                                                            </div> -->
                                                            <div class="errorinputmsg text-left" v-if="master.forms.dock_master.current_usage && !validateInput('whole_number', master.forms.dock_master.current_usage)">
                                                            Invalid Current Usage
                                                            </div>
                                                        </div>
                                                        <div class="pull-right text-right col-12 col-sm-6 col-md-6 col-lg-8  mb-1 common_trs_buttons_res">
                                                            <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('dock_master')" @click="saveData('dock_master')" style="margin-top: 18px!important;">Submit</button> 
                                                        </div>

                                                    </div>
                                            </div> 
                                            <div>
                                                <vue-element-loading :active="isMasterListLoading" /> 
                                                <div class="table-responsive datatableview">
                                                    <table class="table table-striped table-hover table_stickys table-col-td-white custom_doctable">
                                                        <thead>
                                                            <tr>
                                                                <!-- <th class="text-left align-middle">Dock id</th> -->
                                                                <th  class="text-left align-middle">Dock Name</th>
                                                                <th  class="text-left align-middle">Dock Type</th>
                                                                <th  class="text-left align-middle">Dock Number</th>
                                                                <th  class="text-center align-middle">Warehouse Name</th>
                                                                <th  class="text-left align-middle" style="min-width:130px;">Created By</th>
                                                                <th  class="text-center align-middle">Created Date Time</th>
                                                                <th  class="text-center align-middle">Dock Location</th>
                                                                <th  class="text-center align-middle">Dock Barcode </th>
                                                                <th  class="text-center align-middle">Max Capacity</th>
                                                                <th  class="text-center align-middle">Current Usage </th>
                                                                <th  class="text-center align-middle">Edit</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="(data,index) in master.dock_master.list"  >
                                                                <tr>
                                                                    <!-- <td data-column="Dock id" class="text-left">
                                                                    
                                                                        <span class="font-weight-bold">{{data.dock_id}}</span>
                                                                    </td> -->
                                                                    <td data-column="Dock Name" class="text-left">{{data.dock_name}}</td>
                                                                    <td data-column="Dock Type" class="text-left">{{data.dock_type}}</td>
                                                                    <td data-column="Dock Number" class="text-left">{{data.dock_number}}</td>
                                                                    <td data-column="Warehouse id" class="text-left">{{data.warehouse_id}}</td>
                                                                    <td data-column="Created By" class="text-left">{{convertEmailIdToName(data.created_by)}}</td>
                                                                    <td data-column="Created Date Time" class="text-left">{{formatTimeStampToMonth(data.created_datetime)}}</td>
                                                                    <td data-column="Dock Location" class="text-left">{{data.dock_location}}</td>
                                                                    <td data-column="Dock Barcode" class="text-left">{{data.dock_barcode}}</td>
                                                                    <td data-column="Max Capacity" class="text-left">{{data.max_capacity}}</td>
                                                                    <td data-column="Current Usage" class="text-left">{{data.current_usage}}</td>
                                                                    <td data-column="Edit" class="text-center">
                                                                        <a @click="openEditForm('dock_master', data.dock_id)">
                                                                            <edit-icon></edit-icon>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-if="!master.dock_master.list.length">
                                                                <tr><td colspan="14" style="text-align: center;">No records found</td></tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                    <pagination v-model="master.dock_master.page" :records="master.dock_master.totalcount" :per-page="master.dock_master.pagelimit" @paginate="(e) => handlePageChange(e, 'dock_master')"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="zone_master" role="tabpanel" aria-labelledby="zone_master_tab" aria-expanded="false">
                                            <div class="container px-0" v-if="zone_master">
                                                <div class="row mx-0">
                                                    
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Sector Name</label>
                                                            <input class="form-control" v-model="master.forms.zone_master.zone_name" type="text" placeholder="Enter Sector Name "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.zone_master.zone_name)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Sector Type</label>
                                                            <input class="form-control" v-model="master.forms.zone_master.zone_type" type="text" placeholder="Enter Sector Type "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.zone_master.zone_type)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Sector Number</label>
                                                            <input class="form-control" v-model="master.forms.zone_master.zone_number" type="text" placeholder="Enter Sector Number "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.zone_master.zone_number)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Warehouse id</label>
                                                            <treeselect placeholder="Select Warehouse" v-model="master.forms.zone_master.warehouse_id"  :options="warehouseList" />
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.zone_master.warehouse_id)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Sector Location</label>
                                                            <input class="form-control" type="text"  v-model="master.forms.zone_master.zone_location" placeholder="Enter Sector Location "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.zone_master.zone_location)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Max Capacity</label>
                                                            <input class="form-control" type="number" v-model="master.forms.zone_master.max_capacity" placeholder="Enter Max Capacity In Number "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!master.forms.zone_master.max_capacity">
                                                            Required field
                                                            </div> -->
                                                            <!-- <div class="errorinputmsg text-left" v-if="master.forms.zone_master.max_capacity && !validateInput('whole_number', master.forms.zone_master.max_capacity)">
                                                            Invalid Max Capacity
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Current Usage</label>
                                                            <input class="form-control" type="number" v-model="master.forms.zone_master.current_usage" placeholder="Enter Current Usage"/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!master.forms.zone_master.current_usage">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Safety Information</label>
                                                            <textarea class="form-control" id="#" rows="3" v-model="master.forms.zone_master.safety_information" placeholder="Enter Safety Information"></textarea>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.zone_master.safety_information)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="pull-right text-right col-12 col-sm-12 col-md-12 col-lg-4  mb-1 common_trs_buttons_res">
                                                            <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('zone_master')" @click="saveData('zone_master')" style="margin-top: 18px!important;">Submit</button> 
                                                        </div>

                                                    </div>
                                            </div> 
                                            <div>
                                                <vue-element-loading :active="isMasterListLoading" />
                                                <div class="table-responsive datatableview">
                                                    <table class="table table-striped table-hover table_stickys table-col-td-white custom_doctable">
                                                        <thead>
                                                            <tr>
                                                                <!-- <th class="text-left align-middle">Zone id</th> -->
                                                                <th  class="text-left align-middle">Sector Name</th>
                                                                <th  class="text-left align-middle">Sector Type</th>
                                                                <th  class="text-left align-middle">Sector Number</th>
                                                                <th  class="text-center align-middle">Warehouse Name</th>
                                                                <th  class="text-center align-middle">Created By </th>
                                                                <th  class="text-center align-middle">Created Date Time</th>
                                                                <th  class="text-center align-middle">Sector Location</th>
                                                                <th  class="text-center align-middle"> Sector Barcode</th>
                                                                <th  class="text-center align-middle"> Max Capacity</th>
                                                                <th  class="text-center align-middle">Current Usage</th>
                                                                <th  class="text-center align-middle">Safety Information </th>
                                                                <th  class="text-center align-middle">Edit</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="(data,index) in master.zone_master.list"  >
                                                                <tr>
                                                                    <!-- <td data-column="Zone id" class="text-left">
                                                                    
                                                                        <span class="font-weight-bold">{{data.zone_id}}</span>
                                                                    </td> -->
                                                                    <td data-column="Zone Name" class="text-left">{{data.zone_name}}</td>
                                                                    <td data-column="Zone Type" class="text-left">{{data.zone_type}}</td>
                                                                    <td data-column="Zone Number" class="text-left">{{data.zone_number}}</td>
                                                                    <td data-column="Warehouse id" class="text-left">{{data.warehouse_id}}</td>
                                                                    <td data-column="Created By" class="text-left">{{convertEmailIdToName(data.created_by)}}</td>
                                                                    <td data-column="Created Date Time" class="text-left">{{formatTimeStampToMonth(data.created_datetime)}}</td>
                                                                    <td data-column="Zone Location" class="text-left">{{data.zone_location}}</td>
                                                                    <td data-column="Zone Barcode" class="text-left">{{data.zone_barcode}}</td>
                                                                    <td data-column="Max Capacity" class="text-left">{{data.max_capacity}}</td>
                                                                    <td data-column="Current Usage" class="text-left">{{data.current_usage}}</td>
                                                                    <td data-column="Safety Information" class="text-left">{{data.safety_information}}</td>
                                                                    <td data-column="Edit" class="text-left">
                                                                        <a @click="openEditForm('zone_master', data.zone_id)">
                                                                            <edit-icon></edit-icon>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-if="!master.zone_master.list.length">
                                                                <tr><td colspan="14" style="text-align: center;">No records found</td></tr>
                                                            </template>
                                                        
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                    <pagination v-model="master.zone_master.page" :records="master.zone_master.totalcount" :per-page="master.zone_master.pagelimit" @paginate="(e) => handlePageChange(e, 'zone_master')"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="vendor_master" role="tabpanel" aria-labelledby="vendor_master_tab" aria-expanded="false">
                                            <div class="container px-0" v-if="vendor_master">
                                                <div class="row mx-0">
                                                    
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vendor Name</label>
                                                            <input class="form-control" type="text" v-model="master.forms.vendor_master.vendor_name" placeholder="Enter Vendor Name "/>
                                                            <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vendor_master.vendor_name)">
                                                            Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Contact Person</label>
                                                            <input class="form-control" v-model="master.forms.vendor_master.contact_person"  type="text" placeholder="Enter Contact Person"/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vendor_master.contact_person)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Contact Number</label>
                                                            <input class="form-control" type="text" v-model="master.forms.vendor_master.contact_number"  placeholder="Enter Contact Number"/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vendor_master.contact_number)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Email</label>
                                                            <input class="form-control" type="text" v-model="master.forms.vendor_master.email"  placeholder="Enter Email id "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vendor_master.email)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Address</label>
                                                            <textarea class="form-control" id="#" rows="1" v-model="master.forms.vendor_master.address" placeholder="Enter Address Details "></textarea>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vendor_master.address)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Country</label>
                                                            <input class="form-control" type="text" v-model="master.forms.vendor_master.country" placeholder="Enter Address Details "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vendor_master.country)">
                                                            Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">State</label>
                                                            <treeselect placeholder="Select State" v-model="master.forms.vendor_master.state"  :options="stateList" @input="filterCityListStateWise"/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vendor_master.state)">
                                                                Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">City</label>
                                                            <treeselect placeholder="Select City" v-model="master.forms.vendor_master.city"  :options="cityListStateWise" />
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vendor_master.city)">
                                                                Required field
                                                            </div> -->
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Pincode</label>
                                                            <input class="form-control" type="text" v-model="master.forms.vendor_master.pincode" placeholder="Enter Pin Code "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vendor_master.pincode)">
                                                            Required field
                                                            </div> -->
                                                            <div class="errorinputmsg text-left" v-if="getTrimmedString(master.forms.vendor_master.pincode) && !validateInput('pincode', master.forms.vendor_master.pincode)">
                                                                Invalid Pincode
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label class="form-label text-left w-100">Vendor Rating</label>
                                                            <input class="form-control" type="number" step="any" v-model="master.forms.vendor_master.vendor_rating" placeholder="Enter Vendor Rating "/>
                                                            <!-- <div class="errorinputmsg text-left" v-if="!getTrimmedString(master.forms.vendor_master.vendor_rating)">
                                                            Required field
                                                            </div> -->
                                                            <div class="errorinputmsg text-left" v-if="master.forms.vendor_master.vendor_rating && !validateInput('rating', master.forms.vendor_master.vendor_rating)">
                                                            Invalid Rating ( 0 <= Vendor Rating <= 5.00 )
                                                            </div>
                                                        </div>
                                                        <div class="pull-right text-right col-12 col-sm-12 col-md-12 col-lg-8  mb-1 common_trs_buttons_res">
                                                            <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('vendor_master')" @click="saveData('vendor_master')" style="margin-top: 18px!important;">Submit</button> 
                                                        </div>

                                                    </div>
                                            </div> 
                                            <div>
                                            <vue-element-loading :active="isMasterListLoading" />
                                                <div class="table-responsive datatableview">
                                                    <table class="table table-striped table-hover table_stickys table-col-td-white custom_doctable">
                                                        <thead>
                                                            <tr>
                                                                <!-- <th class="text-left align-middle">Vendor id</th> -->
                                                                <th  class="text-left align-middle">Vendor Name </th>
                                                                <th  class="text-left align-middle">Contact Person</th>
                                                                <th  class="text-left align-middle">Contact Number</th>
                                                                <th  class="text-left align-middle">Email</th>
                                                                <th  class="text-center align-middle"> Address</th>
                                                                <th  class="text-left align-middle">City</th>
                                                                <th  class="text-left align-middle">State</th>
                                                                <th  class="text-center align-middle">Pincode</th>
                                                                <th  class="text-center align-middle"> Country</th>
                                                                <th  class="text-center align-middle"> Is Active</th>
                                                                <th  class="text-center align-middle"> Created By </th>
                                                                <th  class="text-center align-middle">Created Date Time</th>
                                                                <th  class="text-center align-middle"> Vendor Rating</th>
                                                                <th  class="text-center align-middle"> Edit</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="(data,index) in master.vendor_master.list"  >
                                                                <tr>
                                                                    <!-- <td data-column="Vendor id" class="text-left">
                                                                    
                                                                        <span class="font-weight-bold">{{data.vendor_id}}</span>
                                                                    </td> -->
                                                                    <td data-column="Vendor Name" class="text-left">{{data.vendor_name}}</td>
                                                                    <td data-column="Contact Person" class="text-left">{{data.contact_person}}</td>
                                                                    <td data-column="Contact Number" class="text-left">{{data.contact_number}}</td>
                                                                    <td data-column="Email" class="text-left">{{data.email}}</td>
                                                                    <td data-column="Address" class="text-left">{{data.address}}</td>
                                                                    <td data-column="City" class="text-left">{{data.city}}</td>
                                                                    <td data-column="State" class="text-left">{{data.state}}</td>
                                                                    <td data-column="Pincode" class="text-left">{{data.pincode}}</td>
                                                                    <td data-column="Country" class="text-left">{{data.country}}</td>
                                                                    <td data-column="Is Active" class="text-left" v-if="data.is_active == 1"><span class="badge badge-pill badge-success mr-1">Active</span></td>
                                                                    <td data-column="Inactive" class="text-left" v-else><span class="badge badge-pill badge-light-danger mr-1">Inactive</span></td>
                                                                    <td data-column="Created By" class="text-left">{{convertEmailIdToName(data.created_by)}}</td>
                                                                    <td data-column="Created Date Time" class="text-left">{{formatTimeStampToMonth(data.created_datetime)}}</td>
                                                                    <td data-column="Vendor Rating" class="text-left">{{data.vendor_rating}}</td>
                                                                    <td data-column="Edit" class="text-left">
                                                                        <a @click="openEditForm('vendor_master', data.vendor_id)">
                                                                            <edit-icon></edit-icon>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-if="!master.vendor_master.list.length">
                                                              <tr><td colspan="14" style="text-align: center;">No records found</td></tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                    <pagination v-model="master.vendor_master.page" :records="master.vendor_master.totalcount" :per-page="master.vendor_master.pagelimit" @paginate="(e) => handlePageChange(e, 'vendor_master')"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="zone_to_dock_mapping" role="tabpanel" aria-labelledby="zone_to_dock_mapping_tab" aria-expanded="false">
                                            <div class="container px-0" v-if="dockMappingMasters">
                                                <div class="row mx-0">
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label for="dock_id" class="form-label text-left w-100">Dock Name <span class="requiredField">*</span></label>
                                                            <treeselect placeholder="Select Dock" v-model="master.forms.map_dock_to_sector.dock_id" :options="master.forms.map_dock_to_sector.dockList" @input="filterZoneListDockWise"/>
                                                              <div class="errorinputmsg text-left" v-if="!master.forms.map_dock_to_sector.dock_id">
                                                                Required field
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                                                            <label for="zone_id" class="form-label text-left w-100">Sector Name <span class="requiredField">*</span></label>
                                                            <treeselect placeholder="Enter min 2 chars to search Sector Name" v-model="master.forms.map_dock_to_sector.zone_id" :options="master.forms.map_dock_to_sector.filterDockWiseZoneList" multiple/>
                                                            <div class="errorinputmsg text-left" v-if="!master.forms.map_dock_to_sector.zone_id">
                                                            Required field
                                                          </div>
                                                        </div>
                                                        <div class="pull-right text-right col-12 col-sm-12 col-md-12 col-lg-4 mb-1 common_trs_buttons_res">
                                                            <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm('map_dock_to_sector')" @click="saveData('map_dock_to_sector')" style="margin-top: 18px!important;">Submit</button> 
                                                        </div>

                                                    </div>
                                            </div> 
                                            <div>
                                                <vue-element-loading :active="isMasterListLoading" />
                                                <div class="table-responsive datatableview">
                                                    <table class="table table-striped table-hover table_stickys table-col-td-white custom_doctable">
                                                        <thead>
                                                            <tr>
                                                                <!-- <th class="text-left align-middle">Mapping id</th> -->
                                                                <th  class="text-left align-middle"> Dock Name</th>
                                                                <th  class="text-left align-middle">Sector Name </th>
                                                                <th  class="text-left align-middle"> Created By</th>
                                                                <th  class="text-left align-middle">Created Date Time</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <template v-for="(data,index) in master.map_dock_to_sector.list"  >
                                                                <tr>
                                                                    <!-- <td data-column="Mapping id" class="text-left">
                                                                        <span class="font-weight-bold">{{data.mapping_id}}</span>
                                                                    </td> -->
                                                                    <td data-column="Dock id"  class="text-left">{{data.dock_id}}</td>
                                                                    <td data-column="Zone id" class="text-left">{{data.zone_id}}</td>
                                                                    <td data-column="Created By" class="text-left">{{convertEmailIdToName(data.created_by)}}</td>
                                                                    <td data-column="Created Date Time"  class="text-left">{{formatTimeStampToMonth(data.created_datetime)}}</td>
                                                                </tr>
                                                            </template>
                                                            <template v-if="!master.map_dock_to_sector.list.length">
                                                              <tr><td colspan="14" style="text-align: center;">No records found</td></tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                    <pagination v-model="master.map_dock_to_sector.page" :records="master.map_dock_to_sector.totalcount" :per-page="master.map_dock_to_sector.pagelimit" @paginate="(e) => handlePageChange(e, 'map_dock_to_sector')"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab-pane" id="upload_master" role="tabpanel" aria-labelledby="upload_tab" aria-expanded="false">
                                            <div class="container px-0">
                                                <div class="row mx-0">
                                                    <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                                                        <label class="form-label text-left w-100">Master Upload Name</label>
                                                        <treeselect :clearable="false" clear="false" placeholder="Select Master Upload Name" v-model="masterUploadName" :options="masterUploadNameList" @select="updateTemplateList" />
                                                    </div>
                                                    <div v-if="masterUploadName === 'shipment_booking_master'" class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                                                        <label class="form-label text-left w-100"> Vehicle No <span class="requiredField">*</span></label>
                                                        <treeselect placeholder="Select Vehicle No" v-model="master.forms.shipment_booking_master.vehicle_id" :options="vehicleNumberList" @input="handleVehicleChange" />
                                                        <!-- <div class="errorinputmsg" v-if="!master.forms.shipment_booking_master.vehicle_number">
                                                            Required field
                                                        </div> -->
                                                    </div>
                                                    <div v-if="masterUploadName === 'shipment_booking_master'" class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8" >
                                                        <label class="form-label text-left w-100">Route Path</label>
                                                        <treeselect placeholder="Select Route Path" v-model="master.forms.shipment_booking_master.route_number" :options="routeNumerList" />
                                                        <!-- <div class="errorinputmsg" v-if="!master.forms.shipment_booking_master.route_number">
                                                            Required field
                                                        </div> -->
                                                    </div>
                                                    <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 intelilinkuploadbtn-right">
                                                        <label class="form-label text-left w-100"> &nbsp;</label>
                                                        <label for="attachment" class="btn btn-relief-success mb-0 intelilinkuploadbtn">Choose File</label>
                                                        <input  type="file" id="attachment" hidden  ref="file" accept=".xlsx, .xls, .csv, .txt" @change="onSelectDoc($event)"/>
                                                        <button class="btn btn-relief-info ml-1 uploadbutton intelilinkuploadbtn" v-on:click.stop.prevent="saveUploadData($event)" :disabled="!master.upload.isValidated" :class="{ 'cursor-not-allowed': master.upload.isValidated === false}">
                                                            <upload-icon size="1.5x" class="custom-class avatar-icon font-medium-2 mr-50">
                                                            </upload-icon> 
                                                            <span>Upload</span>
                                                        </button>
                                                        <button class="btn btn-outline-dark clearButton ml-1 intelilinkuploadbtn" v-on:click.stop.prevent="resetTemplateFileUploadData($event)" :disabled="!master.upload.isValidated"><x-circle-icon size="1.5x" class="custom-class avatar-icon font-medium-2 mr-50"></x-circle-icon> Clear</button>
                                                        <div style="font-weight: 600;" class="mt-2">{{master.upload.fileName ? master.upload.fileName : 'No file selected'}}</div>
                                                            <div style="font-weight: 500; color: green" class="mt-2" v-if="textFileReports.includes(masterUploadName)">Only .txt files are allowed.
                                                            </div>
                                                            <div v-else style="font-weight: 500; color: green" class="mt-2" >  Only .xls, .xlsx, .csv files are allowed.
                                                            </div>
                                                        </div>                                                  
                                                        <div class="col-md-4">
                                                            <label class="form-label text-left w-100"> &nbsp;</label>
                                                            <div class="row" style="align-items: center; justify-content: space-evenly; font-weight: bold">
                                                            <div>Success: <span style="color: green">{{this.master.upload.success}}</span></div>
                                                            <div>Failed: <span style="color: red">{{this.master.upload.failed}}</span></div>
                                                            <div>Updated: <span style="color: orange">{{this.master.upload.updated}}</span></div>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8 mt-2">
                                                        
                                                        <button v-if="textFileReports.includes(masterUploadName)" type="button" class="btn btn-relief-primary mb-1" tabindex="4" @click="syncShipments()"><vue-element-loading :active="isShipmentsSyncing"  />Sync Shipments</button>
                                                        <button v-if="!textFileReports.includes(masterUploadName)" class=" btn btn-outline-secondary ml-1 mb-1 intelilinkuploadbtn" @click="getTemplateFile(masterUploadName)"><file-icon size="1.5x" class="custom-class avatar-icon font-medium-2 mr-50"></file-icon> GET Template</button>
                                                    </div>
                                                    <!-- <div >
                                                        
                                                    </div> -->

                                                </div>
                                                <div class="card" id="document-list">
                                                    <div class="card-body p-0 ps ps--active-x">
                                                        <div class="table-responsive datatableview">
                                                           <table class="table table-striped table-hover table_stickys table-col-td-white custom_doctable"  aria-describedby="mydesc">

                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" class="text-center first-col-sticky" style="min-width:45px;padding-right: 5px;padding-left: 5px;">SR. NO.</th>
                                                                        <th scope="col" class="text-center second-col-sticky">File Name</th>
                                                                        <th scope="col" class="text-center">Created By</th>
                                                                        <th scope="col" class="text-center">Created Date</th>
                                                                        <th scope="col" class="text-center">Download</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <vue-element-loading :active="isMasterListLoading" />
                                                                    <template v-for="(data,index) in master.upload.documentList"  >
                                                                        <tr v-bind:key="index" >
                                                                            <td class="text-center first-col-sticky">{{ index + 1 + master.upload.currPageNum * master.upload.pagelimit }}</td>
                                                                            <td class="text-center second-col-sticky">{{data.file_name}}</td>
                                                                            <td class="text-center">{{convertEmailIdToName(data.createdby)}}</td>
                                                                            <td class="text-center">{{formatTimeStampToMonth(data.createddate)}}</td>
                                                                            <td class="text-center">
                                                                              <a @click="getDownloadedLink(data.file_key)" target="_blank" class="btn btn-icon btn-icon btn-flat-secondary waves-effect">
                                                                                <div class="d-flex align-items-center sitebluecolor"> 
                                                                                  <download-icon size="1.5x" class="custom-class" style="color:#00cfe8" ></download-icon>
                                                                                </div>
                                                                              </a>
                                                                            </td>
                                                                      </tr>
                                                                    </template>
                                                                    <template v-if="master.upload.documentList.length==0">
                                                                      <tr><td colspan="14" style="text-align: center;">No record found</td></tr>
                                                                    </template>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div class="pageCenter text-center mt-4">
                                                            <pagination v-model="master.upload.page" :records="master.upload.totalcount" :per-page="master.upload.pagelimit" @paginate="clickCallbackBulkUploadPage"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                     </div>
                </section>
            </div>
        </div>
        <div class="col-md-6 col-12 modal modal-slide-in fade col-12 show" id="addbutton">
          <div class="modal-dialog sidebar-lg">
            <div class="modal-content p-0" >
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="color:#ffff !important">×</button>
              <div class="modal-header mb-1"  style="background-color:#8c564b !important; border-radius: 0 !important">
                <h5 class="modal-title" style="color:#ffff !important">
                  <span class="align-middle ml-50"> {{ master.forms.map_dock_to_sector.isEdit ? 'Update' : 'Add' }} Dock to Sector Mapping</span>
                </h5>
              </div>
              <div class="modal-body flex-grow-1 devUniqueForm p-0">
                <form class="form form-vertical">
                  <div class="row mx-0">
                    <div class="col-12 form-group">
                      <label for="dock_id">Dock Name <span class="requiredField">*</span></label>
                      <treeselect placeholder="Enter min 2 chars to search Dock Name" v-model="master.forms.map_dock_to_sector.dock_id" :options="master.forms.map_dock_to_sector.dockList" v-on:search-change="dockNameSearch"/>
                      <div class="errorinputmsg" v-if="!master.forms.map_dock_to_sector.dock_id">
                        Required field
                      </div>
                    </div>
                    <div class="col-12 form-group">
                      <label for="zone_id">Sector Name <span class="requiredField">*</span></label>
                      <treeselect placeholder="Enter min 2 chars to search zone Name" v-model="master.forms.map_dock_to_sector.zone_id" :options="master.forms.map_dock_to_sector.filterDockWiseZoneList" v-on:search-change="zoneNameSearch" multiple/>
                      <div class="errorinputmsg" v-if="!master.forms.map_dock_to_sector.zone_id">
                        Required field
                      </div>
                    </div>
                    <div class="col-12 mg-top1">
                      <button type="button" class="btn btn-relief-primary mr-1" tabindex="4" @click="saveData()" :disabled="!validateForm()">{{ this.master.forms.map_dock_to_sector.isEdit ? 'Update': 'Save' }}</button>
                      <button type="button" class="btn btn-outline-secondary" @click="resetform()">Clear</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
import moment from "moment";
import Pagination from 'vue-pagination-2'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import Treeselect from '@riophae/vue-treeselect'
import VueElementLoading from 'vue-element-loading'
import { XCircleIcon, FileIcon, UploadIcon, DownloadIcon, EditIcon } from 'vue-feather-icons';
import CONSTANT from "../constants.js"
import { read, utils } from "xlsx";
import schema from "../utils/schema";
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"

export default({
    name:'mastersTable',
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        Treeselect,
        DatePicker,
        VueElementLoading,
        Pagination,
        UploadIcon,
        FileIcon,
        XCircleIcon,
        DownloadIcon,
        EditIcon,
        Pagination,
    },
    data() {
        return {
            un:'',
            isLoading: false,
            isShipmentsSyncing: false,
            isMasterListLoading: true,
            pagefeatures:[],
            isFormEdit: false,
            warehouse_master: false,  
            vehicle_registration_master: false, 
            gate_master: false,
            dock_master: false, 
            zone_master: false,
            vendor_master: false,
            dockMappingMasters: false,
            vendorList: [],
            warehouseList: [],
            gateList: [],
            dockList: [],
            zoneList: [],
            vehicleList: [],
            vehicleNumberList: [],
            vehiclesRouteNumerList: [],
            routeNumerList: [],
            statuslist: [],
            stateList: [],
            cityList: [],
            cityListStateWise: [],
            routeList: [],
            masterUploadName: 'warehouse_master',
            textFileReports: ['tab_scan_report', 'trip_challan'],
            search: {
                vehicle_registration_master: {
                    vehicle_id: null
                },
                warehouse_master: {
                    warehouse_id: null
                },
                gate_master: {
                    gate_id: null
                },
                dock_master: {
                    dock_id: null
                },
                zone_master: {
                    zone_id: null
                },
                vendor_master: {
                    vendor_id: null
                },
                map_dock_to_sector: {
                    dock_id: null,
                    zone_id: null,
                },
                ou_to_sector: {
                    ou: null,
                    zone_id: null,
                },
            },
            searchPanelName: 'warehouse_master',
            searchPanelNameList: [
                { id: 'warehouse_master', label: 'Warehouse', url: '/master/bulk/createwarehouse', createUrl: '/master/createwarehouse', caller: this.getWarehouseList, key: 'warehouse_id' },
                { id: 'gate_master', label: 'Gate', url: '/master/bulk/CreateGate', createUrl: '/master/CreateGate',caller: this.getGateMaster, key: 'gate_id' },
                { id: 'dock_master', label: 'Dock', url: '/master/bulk/createdock', createUrl: '/master/createdock', caller: this.getDockMaster , key: 'dock_id' },
                { id: 'zone_master', label: 'Sector', url: '/master/bulk/createzone', createUrl: '/master/createzone', caller: this.getZoneMaster, key: 'zone_id' },
                { id: 'vendor_master', label: 'Vendor', url: '/master/bulk/CreateVendor', createUrl: '/master/CreateVendor', caller: this.getVendorMaster, key: 'vendor_id' },
                { id: 'vehicle_registration_master', label: 'Vehicles', url: '/master/bulk/createvehicle', createUrl: '/master/createvehicle', caller: this.getVehicleRegistrationMaster, key: 'vehicle_id' },
            ],
            masterUploadNameList: [
                { id: 'warehouse_master', label: 'Warehouse', url: '/master/bulk/createwarehouse', createUrl: '/master/createwarehouse', caller: this.getWarehouseList, key: 'warehouse_id' },
                { id: 'gate_master', label: 'Gate', url: '/master/bulk/CreateGate', createUrl: '/master/CreateGate',caller: this.getGateMaster, key: 'gate_id' },
                { id: 'dock_master', label: 'Dock', url: '/master/bulk/createdock', createUrl: '/master/createdock', caller: this.getDockMaster , key: 'dock_id' },
                { id: 'zone_master', label: 'Sector', url: '/master/bulk/createzone', createUrl: '/master/createzone', caller: this.getZoneMaster, key: 'zone_id' },
                { id: 'map_dock_to_sector', label: 'Sector-Dock Map', key: '', createUrl: '/master/mapping/dock-to-zone/create', url: "/master/bulk/mapping/dock-to-zone/create", caller: () => {} },
                { id: 'ou_to_sector', label: 'OU-Sector Map', key: '', createUrl: '', url: "/master/bulk/mapping/ou-to-zone/create", caller: () => {} },
                { id: 'vendor_master', label: 'Vendor', url: '/master/bulk/CreateVendor', createUrl: '/master/CreateVendor', caller: this.getVendorMaster, key: 'vendor_id' },
                { id: 'vehicle_registration_master', label: 'Vehicles', url: '/master/bulk/createvehicle', createUrl: '/master/createvehicle', caller: this.getVehicleRegistrationMaster, key: 'vehicle_id' },
                // { id: 'shipment_booking_master', label: 'Unloading Vehicle Trip Challan', url: '/master/bulk/shipment_booking/create', createUrl: '/master/shipment_booking/create', caller: () => {}, key: 'booking_id' },
                { id: 'route_details', label: 'Routes', url: '/master/bulk/routes/create', createUrl: '', caller: () => {}, key: 'route_number' },
                { id: 'vehicle_route_controlling', label: 'Route-Vehicle Controlling', url: '/master/bulk/route-vehicle-controlling/create', createUrl: '', caller: () => {}, key: 'route_number' },
                { id: 'trip_challan', label: 'Trip Challan', url: '/shipments/read/trip-challan-report', caller: () => {}, key: 'tab_scan_report' },
                { id: 'tab_scan_report', label: 'Trip Details', url: '/shipments/read/tab-scan-report', caller: () => {}, key: 'tab_scan_report' },
            ],
            gateTypeList: [
                { id: 'in', label: 'In' },
                { id: 'out', label: 'Out' },
                { id: 'both', label: 'Both' },
            ],
            vehicleTransactioTypeList: [
                { id: 'BOOKING', label: 'Booking' },
                { id: 'DELIVERY', label: 'Delivery' }, 
                { id: 'LOADING', label: 'Loading' },                
            ],
            master: {
                warehouseList: [],
                vehicleRegistrationList: [],
                gateList: [],
                dockList: [],
                zoneList: [],
                vendorList: [],
                zoneToDockMappingList: [],
                warehouse_master: {
                    url: "/master/warehouses",
                    list: [],
                    totalcount: 0,
                    pageCount: 0,
                    page: 1,
                    pagelimit: CONSTANT.LIMIT,
                    currPageNum: 0,
                    pageoffset: 1,
                    presignedUrls: [],
                },
                gate_master: {
                    url: "/master/gates",
                    list: [],
                    totalcount: 0,
                    pageCount: 0,
                    page: 1,
                    pagelimit: CONSTANT.LIMIT,
                    currPageNum: 0,
                    pageoffset: 1,
                    presignedUrls: [],
                },
                dock_master: {
                    url: "/master/docks",
                    list: [],
                    totalcount: 0,
                    pageCount: 0,
                    page: 1,
                    pagelimit: CONSTANT.LIMIT,
                    currPageNum: 0,
                    pageoffset: 1,
                    presignedUrls: [],
                },
                zone_master: {
                    url: "/master/zones",
                    list: [],
                    totalcount: 0,
                    pageCount: 0,
                    page: 1,
                    pagelimit: CONSTANT.LIMIT,
                    currPageNum: 0,
                    pageoffset: 1,
                    presignedUrls: [],
                },
                map_dock_to_sector: {
                    url: "/master/mapping/dock-to-zone",
                    list: [],
                    totalcount: 0,
                    pageCount: 0,
                    page: 1,
                    pagelimit: CONSTANT.LIMIT,
                    currPageNum: 0,
                    pageoffset: 1,
                    presignedUrls: [],
                },
                vendor_master: {
                    url: "/master/vendors",
                    list: [],
                    totalcount: 0,
                    pageCount: 0,
                    page: 1,
                    pagelimit: CONSTANT.LIMIT,
                    currPageNum: 0,
                    pageoffset: 1,
                    presignedUrls: [],
                },
                vehicle_registration_master: {
                    url: "/master/vehicle_registrations",
                    list: [],
                    totalcount: 0,
                    pageCount: 0,
                    page: 1,
                    pagelimit: CONSTANT.LIMIT,
                    currPageNum: 0,
                    pageoffset: 1,
                    presignedUrls: [],
                },
                forms: {
                    map_dock_to_sector: {
                        dock_id: null,
                        zone_id: null,
                        isEdit: false,
                        dockList: [],
                        zoneList: [],
                        filterDockWiseZoneList: [],
                    },
                    warehouse_master: {
                        warehouse_id: null,
                        warehouse_name: null,
                        city: null,
                        location: null,
                        state: null,
                        pincode: null,
                        latitude: null,
                        longitude: null,
                    },
                    vehicle_registration_master: {
                        vehicle_id: null,
                        vehicle_type: null,
                        vehicle_size: null,
                        vehicle_tonnage: null,
                        vendor_id: null,
                        vehicle_number_plate: null,
                        vehicle_rc_no: null,
                        vehicle_documents: null,
                        vehicle_condition: null,
                        vehicle_attached_to: null,
                        last_maintenance_date: null,
                        next_maintenance_due_date: null,
                        vehicle_transaction_type: null,
                        route: null,
                        vehicle_drivername: null,
                        driver_mobileno: null
                    },
                    gate_master: {
                        gate_id: null,
                        gate_name: null,
                        gate_type: null,
                        operational_hours: null,
                        usage_type: null,
                    },
                    dock_master: {
                        dock_id: null,
                        dock_name: null,
                        dock_type: null,
                        dock_number: null,
                        warehouse_id: null,
                        dock_location: null,
                        max_capacity: null,
                        current_usage: null,
                    },
                    zone_master: {
                        zone_id: null,
                        zone_name: null,
                        zone_type: null,
                        zone_number: null,
                        warehouse_id: null,
                        zone_location: null,
                        max_capacity: null,
                        current_usage: null,
                        safety_information: null,
                    },
                    vendor_master: {
                        vendor_id: null,
                        vendor_name: null,
                        contact_person: null,
                        contact_number: null,
                        email: null,
                        address: null,
                        city: null,
                        state: null,
                        pincode: null,
                        country: null,
                        vendor_rating: null,
                    },
                    shipment_booking_master: {
                        vehicle_id: null,
                        route_number: null,
                    },
                },
                upload: {
                    documentList: [],
                    supportedExtensions: ['xls', 'xlsx', 'csv'],
                    file: null,
                    fileName: null,
                    payload: [],
                    isValidated: false,
                    success: 0,
                    failed: 0,
                    updated: 0,
                    totalcount: 0,
                    pageCount: 0,
                    page:1,
                    currPageNum: 0,
                    pageoffset:1,
                    pagelimit: CONSTANT.LIMIT,
                }
            },
            torch: false,
            captures: {
                rc: {
                    stream: null,
                    file: null
                },
            },
            photoCaptureSound: 'sound/iphone-camera-capture-6448.wav',
        }  
    } ,
    mounted(){
        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
        if (feather) {
            feather.replace({
                width: 14,
                height: 14
            });
        }
        
        setTimeout(function () {
          $("#commonaddmodule").attr("data-target", "#addbutton");
          $(".devEditEle").attr("data-target", "#addbutton");
        }, 1000);
    },
    created() {
        this.getVendorList()
        this.getWarehouseMaster()
        this.getWarehouseList()
        this.getGateList()
        this.getSectorList()
        this.getVehicleList()

        this.getStateList()
        this.getCityList()
        this.getDockList()
        this.getZoneList()
        this.get_template_files()
    },
    methods: {
        handleSearchPanelNameList() {

        },
        searchReset() {
            this.search = {
                vehicle_registration_master: {
                    vehicle_id: null
                },
                warehouse_master: {
                    warehouse_id: null
                },
                gate_master: {
                    gate_id: null
                },
                dock_master: {
                    dock_id: null
                },
                zone_master: {
                    zone_id: null
                },
                vendor_master: {
                    vendor_id: null
                },
                map_dock_to_sector: {
                    dock_id: null,
                    zone_id: null,
                },
                ou_to_sector: {
                    ou: null,
                    zone_id: null,
                },
            }
            this.searchPanel(this.searchPanelName)
        },
        async capturePhoto(id2, index="") {
            let id = id2 + index
            let canvas = document.querySelector(`#${id}-canvas`);
            let video = document.querySelector(`#${id}-video`);
            canvas.style.display = "block"
            let imgWidth = video.videoWidth ?? canvas.width
            let imgHeight = video.videoHeight ?? canvas.height
            this.width = video.videoWidth
            this.height = video.videoHeight
            var hRatio = canvas.width  / imgWidth    ;
            var vRatio =  canvas.height / imgHeight  ;
            var ratio  = Math.min ( hRatio, vRatio );
            var centerShift_x = ( canvas.width - imgWidth*ratio ) / 2;
            var centerShift_y = ( canvas.height - imgHeight*ratio ) / 2;
            canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
            this.PlaySound(`${id}-sound`)
            let image_data_url = canvas.toDataURL('image/jpeg');
            

            let stream = video.srcObject
            let tracks = stream.getVideoTracks()
            if(this.torch && tracks.length) {
                const videoTrack = tracks[0];
                await videoTrack.applyConstraints({torch: false});
            }
            // data url of the image
            video.srcObject = null
            const storeFile = (file) => {
                if(index !== "") {
                    this.captures[id2][`file${index}`] = file
                } else {
                    this.captures[id2].file = file
                }
            }
            document.querySelector(`#${id}-canvas`).toBlob(function(blob) {
                storeFile(new File([blob], `${id}_photo.jpg`, { type: 'image/jpeg' }))
            }, 'image/jpeg');
            if(this.captures[id2].stream) {
                this.captures[id2].stream.getTracks().forEach(function(track) {
                    track.stop();
                });
            }
            video.style.display = "none";
        },
        async turnOnCamera(id2,index="") {
            this.isLoading = true
            // Capture logic here
            let id = id2 + index
            let video = document.getElementById(`${id}-video`)
            video.style.display = "block";

            let videoConstraints = {
                audio: false,
                video: {
                    width: { ideal: 4096 },
                    height: { ideal: 2160 },
                    facingMode: {
                        exact: "environment"
                    }
                }
            }
            // let videoConstraints = { video: { facingMode: "user" }, audio: false }
            if(this.camera) {
                videoConstraints = { video: { facingMode: "user" }, audio: false }
            }
            // let videoConstraints = { video: { facingMode: "user" }, audio: false }
            try {

                let stream = await navigator.mediaDevices.getUserMedia(videoConstraints);
                let tracks = stream.getVideoTracks()
                if(this.torch) {
                    if(tracks.length) {
                        const videoTrack = tracks[0];
                        await videoTrack.applyConstraints({torch: true});
                    }
                } else {
                    if(tracks.length) {
                        const videoTrack = tracks[0];
                        await videoTrack.applyConstraints({torch: false});
                    }
                }
                this.captures[id2].stream = stream
                video.srcObject = stream;
            } catch(e) {
                video.style.display = "none";
                this.displayError(e)
            }
            this.isLoading = false
        },
        PlaySound(soundObjId) {
          var sound = document.getElementById(soundObjId);
          sound.play();
        },
        syncShipments() {
            this.isShipmentsSyncing = true
            let url = "/shipments/sync-shipments"
            this.makeRequest("POST", url)
                .then(result => {
                    this.isShipmentsSyncing = false
                    this.master.upload.success = result.data.success
                    this.master.upload.failed = result.data.failed
                    this.master.upload.updated = result.data.updated
                    let error = result.data.error
                    if(error.length) {
                        this.exportJsonData(error)
                    }
                    if(result.data.status) {
                        this.sweetAlertSnackbar(result.data.message, 'success', 'top')
                    } else {
                        this.sweetAlertSnackbar(result.data.message, 'error')
                    }
                })
                .catch(e => {
                    this.isShipmentsSyncing = false
                    this.displayError(e)
                })
        },
        getVehicleNumberList() {
            this.searchNameMasterList('vehicle_registration_master', 'vehicle_number_plate', null, 'vehicle_id', 'vehicle_transaction_type')
                .then(result => {
                  this.vehicleNumberList = result.data
                  this.getRouteNumbers()
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        getVehicleList() {
            this.searchNameMasterList('vehicle_registration_master', 'vehicle_number_plate', null, 'vehicle_id')
                .then(result => {
                  this.vehicleList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        getRouteNumbers() {
            this.makeRequest("post", "/routes/route-vehicle-controlling/get-routes-by-vehicle", [])
                .then(result => {
                    this.vehiclesRouteNumerList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        handleVehicleChange(id) {
            this.master.forms.shipment_booking_master.route_number = null
            if(id) {
                this.routeNumerList = this.vehiclesRouteNumerList.filter(v => v.vehicle_id == id)
            } else {
                this.routeNumerList = []
            }
        },
        openEditForm(form, id) {
            this[form] = true
            this.isFormEdit = true
            this.populateEditForm(form, id)
        },
        populateEditForm(form, id) {
            let master = this.masterUploadNameList.find(master => master.id === form)
            if(master) {
                this.isLoading = true
                let url = `/master/${form}/${id}?key=${master.key}`
                this.makeRequest("GET", url)
                    .then(result => {
                        this.isLoading = false
                        if(result.data.status) {
                            this.master.forms[form] = result.data.data
                        } else {
                            this[form] = false
                            this.isFormEdit = false
                        }
                    })
                    .catch(e => {
                        this[form] = false
                        this.isFormEdit = false
                        this.displayError(e)
                    })
            } else {
                this[form] = false
                this.isFormEdit = false
                this.sweetAlertSnackbar("Master form was not found", "error")
            }
        },
        onSelectDoc(event) {
            let currFile = event.target.files[0]
            this.master.upload.file = currFile
            let fileName = currFile.name
            this.master.upload.fileName = fileName
            let masterUploadName = this.masterUploadName
            $('input[type="file"]').val("");
            let ext = fileName.split('.').pop().toLowerCase()
            if(!this.textFileReports.includes(masterUploadName) && !this.master.upload.supportedExtensions.includes(ext)) {
                this.sweetAlertSnackbar(`Invalid Extension`, 'error')
                return
            }
            if(this.textFileReports.includes(masterUploadName) && !['txt'].includes(ext)) {
                this.sweetAlertSnackbar(`Invalid Extension. Only .txt files are allowed`, 'error')
                return
            }
            if(this.textFileReports.includes(masterUploadName)) {
                this.master.upload.isValidated = true
                return
            }

            const callSnackbarDisplay = (error, type) => this.sweetAlertSnackbar(error, type)
            const assignBulkUploadPayload = (payload) => this.master.upload.payload = payload
            const assignIsValidated = (val) => {
                this.master.upload.isValidated = val
                if(!val) {
                    this.resetTemplateFileUploadData()
                }
            }

            if (currFile.size > 1024 * 1024 * 25) {
                this.sweetAlertSnackbar("Document of size above 25MB is not allowed", 'error')
                return
            }
            var reader = new FileReader();
            reader.readAsArrayBuffer(currFile);
            let getColumnList = this.getColumnList
            reader.onload = function(e) {
                var data = new Uint8Array(e.target.result);
                var workbook = read(data, {type: 'array', cellDates: true, raw: false, dateNF:"dd-mm-yyyy"});
                let sheetName = workbook.SheetNames[0]
                /* DO SOMETHING WITH workbook HERE */
                let worksheet = workbook.Sheets[sheetName];
                let readData = utils.sheet_to_json(worksheet);
                const { value, error } = schema[masterUploadName].validate(readData, schema.validationOptions);
                if(error) {
                    let message = "ValidationError: Some fields were invalidated. Please fill the data properly and choose the file again."
                    if( error?.details) {
                        message = error?.details[0].message.slice(0,300)
                    }
                    callSnackbarDisplay(message, 'error')
                    assignIsValidated(false)
                } else {
                    callSnackbarDisplay('Fields Validated, Click Upload button to save Attributes', 'success')
                    let columns = getColumnList(masterUploadName)
                    let payload = value.map(item => {
                        let obj = {}
                        columns.forEach(col => {
                            if(col.format) {
                                obj[col.id] = col.format(item[col.label])
                            } else {
                                obj[col.id] = item[col.label]
                            }
                        })
                        return obj
                    })
                    assignBulkUploadPayload(payload)
                    assignIsValidated(true)
                }
            };
        },
        clickCallbackBulkUploadPage(pageNum) {
            this.master.upload.pageoffset = pageNum
            this.master.upload.currPageNum = pageNum - 1
            this.get_template_files();
            setTimeout(function(){
                $('html, body').animate({
                    scrollTop: $("#document-list").offset().top -70
                });
            }, 500);
        },
        saveUploadData() {
            let masterUploadName = this.masterUploadName
            if(this.textFileReports.includes(masterUploadName)) {
                this.uplodTextFileReport()
                return
            }
            let { url, caller } = this.masterUploadNameList.find(item => item.id === masterUploadName)
            let payload = this.master.upload.payload

            if(masterUploadName === 'shipment_booking_master') {
                if(!this.master.forms.shipment_booking_master.vehicle_id) {
                    this.sweetAlertSnackbar("Please select Vehicle for which shipments belongs!", "error")
                    return
                }
                payload = payload.map(item => {
                    return {
                        ...item,
                        vehicle_id: this.master.forms.shipment_booking_master.vehicle_id,
                        route_number: this.master.forms.shipment_booking_master.route_number
                    }
                })
            }
            this.isLoading = true
            this.makeRequest("POST", url, payload)
                .then(result => {
                    this.isLoading = false
                    if(result && result.data && result.data.status && result.data.data) {
                        this.master.upload.success = result.data.data.success
                        this.master.upload.failed = result.data.data.failed
                        this.master.upload.updated = result.data.data.updated
                        caller()
                        this.UploadFiles()
                        let error = result.data.data.error
                        console.log(error)
                        if(error.length) {
                            this.exportJsonData(error)
                        }
                    } else {
                        this.sweetAlertSnackbar(`${result.data.message}`, 'error')
                    } 
                })
                .catch(e => {
                    this.master.upload.file = null
                    this.master.upload.fileName = null
                    this.master.upload.payload = []
                    if(e?.response?.data?.data?.error) {
                        let error = e.response.data.data.error
                        let fileName = e.response.data.data.fileName
                        if(error.length) {
                            this.exportJsonData(error, `${fileName}_error`)
                        }
                    }
                    this.displayError(e)
                })
        },
        UploadFiles() {
            this.isLoading = true
            let masterUploadName = this.masterUploadName
            let formData = new FormData();
            formData.append("file", this.master.upload.file);
            formData.append("folder", masterUploadName)
            formData.append("table", 'file_master')
            let url = "/files/s3/AddFileInFileMaster"
            axios({
                "content-type": "multipart/form-data",
                method: "POST",
                url: url,
                data: formData,
            })
            .then(result => {
                this.isLoading = false
                this.master.upload.file = null
                this.master.upload.fileName = null
                this.master.upload.payload = []
                this.get_template_files()
                if(result.data.status) {
                    this.sweetAlertSnackbar(result.data.message, 'success', 'top')
                } else {
                    this.sweetAlertSnackbar(result.data.message, 'error')
                }
            })
            .catch(e => {
                this.master.upload.file = null
                this.master.upload.fileName = null
                this.master.upload.payload = []
                this.displayError(e)
            })
        },
        uplodTextFileReport() {
            let masterUploadName = this.masterUploadName
            let formData = new FormData();
            formData.append("file", this.master.upload.file);
            formData.append("folder", masterUploadName)
            formData.append("table", 'file_master')
            let { url, caller } = this.masterUploadNameList.find(item => item.id === masterUploadName)
            axios({
                "content-type": "multipart/form-data",
                method: "POST",
                url: url,
                data: formData,
            })
            .then(result => {
                this.isLoading = false
                // this.get_template_files()
                this.master.upload.success = result.data.success
                this.master.upload.failed = result.data.failed
                this.master.upload.updated = result.data.updated
                this.UploadFiles()
                let error = result.data.error
                if(error.length) {
                    this.exportJsonData(error)
                }
                if(result.data.status) {
                    this.sweetAlertSnackbar(result.data.message, 'success', 'top')
                } else {
                    this.sweetAlertSnackbar(result.data.message, 'error')
                }
            })
            .catch(e => {
                this.master.upload.file = null
                this.master.upload.fileName = null
                this.master.upload.payload = []
                if(e?.response?.data?.error) {
                    let error = e.response.data.error
                    if(error.length) {
                        this.exportJsonData(error)
                    }
                }
                this.displayError(e)
            })
        },
        get_template_files(k=this.masterUploadName) {
            this.isMasterListLoading = true
            let url = `/master/template/files?fileIdentifier=${k}`
            let payload = {
                limit: CONSTANT.LIMIT,
                offset: this.master.upload.pageoffset,
            }
            axios({
                method: 'POST',
                url,
                data: payload,
            }).then(result => {
                this.isMasterListLoading = false
                if(result.data.status) {
                    this.master.upload.documentList = result.data.data.rows
                    this.master.upload.totalcount = result.data.data.count
                    this.master.upload.pageCount = Math.ceil(this.master.upload.totalcount / this.master.upload.pagelimit)
                } else {
                    this.sweetAlertSnackbar(result.data.message, 'error')
                    this.master.upload.documentList = []
                    this.master.upload.totalcount = 0
                    this.master.upload.pageCount = 0
                }
          }).catch(e => {
            this.isMasterListLoading = false
            this.displayError(e)
          })
        },
        updateTemplateList(k) {
            if(k.id === this.masterUploadName) return;
            if(k.id === 'shipment_booking_master') {
                this.master.forms.shipment_booking_master.vehicle_id = null
                this.master.forms.shipment_booking_master.route_number = null
                this.getVehicleNumberList()
            }
            this.get_template_files(k.id)
        },
        resetTemplateFileUploadData() {
            this.master.upload.file = null
            this.master.upload.fileName = null
            this.master.upload.payload = null
            this.master.upload.isValidated = false
            this.master.upload.success = 0
            this.master.upload.failed = 0
            this.master.upload.updated = 0
        },
        validateInput(inputType, fieldValue) {
            if(inputType === 'latitude') {
                let latitude = fieldValue
                return !isNaN(latitude) && latitude >= -90 && latitude <= 90
            } else if(inputType === 'longitude') {
                let longitude = fieldValue
                return !isNaN(longitude) && longitude >= -180 && longitude <= 180
            } else if(inputType === 'pincode') {
                let pattern = /^[1-9][0-9]{5}$/
                return pattern.test(fieldValue)
            } else if(inputType === 'vehicle_number_plate') {
                let pattern = /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/
                return pattern.test(this.master.forms.vehicle_registration_master.vehicle_number_plate)
            } else if(inputType === 'whole_number') {
                return Number.isInteger(parseFloat(fieldValue)) && parseInt(fieldValue) >= 0 && fieldValue !== null
            } else if(inputType === 'rating') {
                return !Number.isInteger(fieldValue) && parseInt(fieldValue) >= 0 && parseInt(fieldValue) <= 5 && fieldValue !== null
            }
            return false
        },
        dockNameSearch(name) {
            if(name && name.trim().length > 1) {
                this.searchNameMasterList('dock_master', 'dock_name', name, 'dock_id')
                .then(result => {
                  this.master.forms.map_dock_to_sector.dockList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
            }
        }, 
        toggleMasterCreate() {
            if(this.isFormEdit) {
                this.resetform('warehouse_master')
            }
            this.isFormEdit = false
            this.warehouse_master = !this.warehouse_master; 
        },
        togglevehicle_Registration() {
            if(this.isFormEdit) {
                this.resetform('vehicle_registration_master')
            }
            this.isFormEdit = false
            this.vehicle_registration_master = !this.vehicle_registration_master;
            if(this.vehicle_registration_master) {
                this.getRoutes()
            }
        },
        toggleGatemaster() {
            if(this.isFormEdit) {
                this.resetform('gate_master')
            }
            this.isFormEdit = false
            this.gate_master = !this.gate_master; 
        },
        toggleDockmaster() {
            if(this.isFormEdit) {
                this.resetform('dock_master')
            }
            this.isFormEdit = false
            this.dock_master = !this.dock_master; 
        },
        togglZoneMaster() {
            if(this.isFormEdit) {
                this.resetform('zone_master')
            }
            this.isFormEdit = false
            this.zone_master = !this.zone_master; 
        }, 
        togglVendorMaster() {
            if(this.isFormEdit) {
                this.resetform('vendor_master')
            }
            this.isFormEdit = false
            this.vendor_master = !this.vendor_master; 
        },
        toggledocMappingCreate() {
            this.dockMappingMasters = !this.dockMappingMasters; 
        },
        zoneNameSearch(name) {
            if(name && name.trim().length > 1) {
                this.searchNameMasterList('zone_master', 'zone_name', name, 'zone_id')
                .then(result => {
                  this.master.forms.map_dock_to_sector.zoneList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
            }
        },
        openAddForm() {
            this.master.forms.map_dock_to_sector.isEdit = false
            this.resetform()
        },
        resetform(tab) {
            if(tab === 'warehouse_master') {
                this.master.forms.warehouse_master.warehouse_name = null
                this.master.forms.warehouse_master.city = null
                this.master.forms.warehouse_master.location = null
                this.master.forms.warehouse_master.state = null
                this.master.forms.warehouse_master.pincode = null
                this.master.forms.warehouse_master.latitude = null
                this.master.forms.warehouse_master.longitude = null
            } else if(tab === 'vehicle_registration_master') {
                this.master.forms.vehicle_type = null
                this.master.forms.vehicle_registration_master.vehicle_id = null
                this.master.forms.vehicle_registration_master.vehicle_size = null
                this.master.forms.vehicle_registration_master.vehicle_tonnage = null
                this.master.forms.vehicle_registration_master.vendor_id = null
                this.master.forms.vehicle_registration_master.vehicle_number_plate = null
                this.master.forms.vehicle_registration_master.vehicle_type = null
                this.master.forms.vehicle_registration_master.vehicle_rc_no = null
                this.master.forms.vehicle_registration_master.vehicle_documents = null
                this.master.forms.vehicle_registration_master.vehicle_condition = null
                this.master.forms.vehicle_registration_master.vehicle_attached_to = null
                this.master.forms.vehicle_registration_master.last_maintenance_date = null
                this.master.forms.vehicle_registration_master.next_maintenance_due_date = null
                this.master.forms.vehicle_registration_master.vehicle_transaction_type = null
                this.master.forms.vehicle_registration_master.route = null
                this.master.forms.vehicle_registration_master.vehicle_drivername = null
                this.master.forms.vehicle_registration_master.driver_mobileno = null
                let canvases = document.getElementsByClassName("c")
                for (let element of canvases) {
                    element.style.display = "none"
                }
                this.captures.rc.stream = null
                this.captures.rc.file = null
            } else if(tab === 'gate_master') {
                this.master.forms.gate_master.gate_name = null
                this.master.forms.gate_master.gate_type = null
                this.master.forms.gate_master.operational_hours = null
                this.master.forms.gate_master.usage_type = null
            } else if(tab === 'dock_master') {
                this.master.forms.dock_master.dock_name = null
                this.master.forms.dock_master.dock_type = null
                this.master.forms.dock_master.dock_number = null
                this.master.forms.dock_master.warehouse_id = null
                this.master.forms.dock_master.dock_location = null
                this.master.forms.dock_master.max_capacity = null
                this.master.forms.dock_master.current_usage = null
            } else if(tab === 'zone_master') {
                this.master.forms.zone_master.zone_name = null
                this.master.forms.zone_master.zone_type = null
                this.master.forms.zone_master.zone_number = null
                this.master.forms.zone_master.warehouse_id = null
                this.master.forms.zone_master.zone_location = null
                this.master.forms.zone_master.max_capacity = null
                this.master.forms.zone_master.current_usage = null
                this.master.forms.zone_master.safety_information = null
            } else if(tab === 'vendor_master') {
                this.master.forms.vendor_master.vendor_name = null
                this.master.forms.vendor_master.contact_person = null
                this.master.forms.vendor_master.contact_number = null
                this.master.forms.vendor_master.email = null
                this.master.forms.vendor_master.address = null
                this.master.forms.vendor_master.city = null
                this.master.forms.vendor_master.state = null
                this.master.forms.vendor_master.pincode = null
                this.master.forms.vendor_master.country = null
                this.master.forms.vendor_master.vendor_rating = null
            } else if(tab === 'map_dock_to_sector') {
                this.master.forms.map_dock_to_sector.dock_id = null
                this.master.forms.map_dock_to_sector.zone_id = null
            }
        },
        saveData(tab) {
            if(!this.validateForm(tab)) {
                this.sweetAlertSnackbar('Form was invalidated', 'error')
                return
            }
            let master = this.masterUploadNameList.find(master => master.id === tab)
            if(!master) {
                this.sweetAlertSnackbar("Master form was not found", "error")
                return
            }
            this.isLoading = true
            let payload = this.master.forms[tab]
            if(tab === "map_dock_to_sector") {
                payload = {
                    dock_id: this.master.forms.map_dock_to_sector.dock_id,
                    zone_id: this.master.forms.map_dock_to_sector.zone_id
                }
            }
            let method = 'POST'
            let url = master.createUrl
            if(tab === "vehicle_registration_master" && this.captures.rc.file) {
                var formData = new FormData();
                formData.append("files", this.captures.rc.file);
                formData.append("folder", 'vehicle_registration_master')
                axios({
                    "content-type": "multipart/form-data",
                    method: "POST",
                    url: "/files/s3/bulkUploadFiles",
                    data: formData,
                })
                .then(result => {
                    if(result.data.status) {
                        let files = result.data.data
                        for(let file of files) {
                            payload.rc_photo = file.fileKey
                        }
                        this.makeRequest(method, url, payload)
                            .then(result => {
                                this.isFormEdit = false
                                this.isLoading = false
                                if(result && result.data && result.data.status) {
                                    this.resetform(tab)
                                    this.getVehicleRegistrationMaster()
                                    this.sweetAlertSnackbar(result.data.message, 'success')
                                } else {
                                    this.sweetAlertSnackbar(result.data.message, 'error')
                                }
                            })
                            .catch(e => {
                                this.isFormEdit = false
                                this.displayError(e)
                            })
                    } else {
                        this.sweetAlertSnackbar(result.data.message, 'error')
                    }
                })
                .catch(e => {
                    this.displayError(e)
                })
            } else {
                this.makeRequest(method, url, payload)
                .then(result => {
                    this.isFormEdit = false
                    this.isLoading = false
                    if(result && result.data && result.data.status) {
                        this.resetform(tab)
                        if(tab === 'warehouse_master') {
                            this.getWarehouseMaster()
                            this.getWarehouseList()
                        } else if(tab === 'vehicle_registration_master') {
                            this.getVehicleRegistrationMaster()
                        } else if(tab === 'gate_master') {
                            this.getGateMaster()
                        } else if(tab === 'dock_master') {
                            this.getDockMaster()
                            this.getDockList()
                        } else if(tab === 'zone_master') {
                            this.getZoneMaster()
                            this.getZoneList()
                        } else if(tab === 'vendor_master') {
                            this.getVendorMaster()
                            this.getVendorList()
                        } else if(tab === 'map_dock_to_sector') {
                            this.getZoneToDockMapping()
                        }
                        this.sweetAlertSnackbar(result.data.message, 'success')
                    } else {
                        this.sweetAlertSnackbar(result.data.message, 'error')
                    }
                })
                .catch(e => {
                    this.isFormEdit = false
                    this.displayError(e)
                })
            }
        },
        disabledPastDates(date) {
            if(!this.master.forms.vehicle_registration_master.last_maintenance_date) return false
            let dayBefore = moment(this.master.forms.vehicle_registration_master.last_maintenance_date).format('YYYY-MM-DD');
            const beforeToday = new Date(dayBefore);
            beforeToday.setHours(0, 0, 0, 0);
            return date < beforeToday; 
        },
        clearDate() {
            this.master.forms.vehicle_registration_master.next_maintenance_due_date = null
        },
        validateForm(tab) {
            let isValid = true
            let formValues = this.master.forms[tab]
            if(tab === 'warehouse_master') {
                if(!this.getTrimmedString(formValues.warehouse_name)
                    || !this.getTrimmedString(formValues.city) || !this.getTrimmedString(formValues.location)
                    || !this.getTrimmedString(formValues.state) || !this.getTrimmedString(formValues.pincode)
                    || (this.getTrimmedString(formValues.latitude) && !this.validateInput('latitude', formValues.latitude)) || (this.getTrimmedString(formValues.latitude) && !this.validateInput('longitude', formValues.longitude)) || !this.validateInput('pincode', formValues.pincode)
                ) {
                    isValid = false
                }
            } else if(tab === 'vehicle_registration_master') {
                if(!this.getTrimmedString(formValues.vehicle_size) || !this.getTrimmedString(formValues.vehicle_number_plate)
                    || !formValues.vendor_id
                ) {
                    isValid = false
                }
                if(!this.isFormEdit && (!formValues.route || (formValues.route && !formValues.route.length))) {
                    isValid = false
                }
            } else if(tab === 'gate_master') {
                if(!this.getTrimmedString(formValues.gate_name)
                    || !this.getTrimmedString(formValues.operational_hours) || !this.getTrimmedString(formValues.usage_type)
                    || !formValues.gate_type
                ) {
                    isValid = false
                }
            }   else if(tab === 'dock_master') {
                if(!this.getTrimmedString(formValues.dock_name)
                    || !this.getTrimmedString(formValues.dock_type) || !this.getTrimmedString(formValues.dock_number)
                    || !formValues.warehouse_id || !this.getTrimmedString(formValues.dock_location)
                    || (this.getTrimmedString(formValues.max_capacity) && !this.validateInput('whole_number', formValues.max_capacity)) || (this.getTrimmedString(formValues.current_usage) && !this.validateInput('whole_number', formValues.current_usage))
                ) {
                    isValid = false
                }
            }  else if(tab === 'zone_master') {
                if(!this.getTrimmedString(formValues.zone_name)
                    || !this.getTrimmedString(formValues.zone_type) || !this.getTrimmedString(formValues.zone_number)
                    || !formValues.warehouse_id || !this.getTrimmedString(formValues.zone_location)
                ) {
                    isValid = false
                }
            }  else if(tab === 'vendor_master') {
                if(!this.getTrimmedString(formValues.vendor_name)
                    || (formValues.vendor_rating && !this.validateInput('rating', formValues.vendor_rating))
                    || (this.getTrimmedString(formValues.pincode) && !this.validateInput('pincode', formValues.pincode))
                ) {
                    isValid = false
                }
            } else if(tab === 'map_dock_to_sector') {
                if(!this.master.forms.map_dock_to_sector.dock_id
                    || !this.master.forms.map_dock_to_sector.zone_id || (this.master.forms.map_dock_to_sector.zone_id && !this.master.forms.map_dock_to_sector.zone_id.length)
                ) {
                    isValid = false
                }
            } else {
                isValid = false
            }
            
            return isValid
        },
        searchPanel(tab) {
            let currTab = document.getElementById(`${tab}_tab`)
            if(currTab) {
                currTab.click()
            }
            if(tab === "warehouse_master") {
                this.getWarehouseMaster()
            } else if(tab === "gate_master") {
                this.getGateMaster()
            } else if(tab === "dock_master") {
                this.getDockMaster()
            } else if(tab === "zone_master") {
                this.getZoneMaster()
            } else if(tab === "vendor_master") {
                this.getVendorMaster()
            } else if(tab === "vehicle_registration_master") {
                this.getVehicleRegistrationMaster()
            }
            // else if(tab === "map_dock_to_sector") {
            //     this.getZoneToDockMapping()
            // } 
        },
        getWarehouseMaster() {
            this.isMasterListLoading = true
            let url = '/master/warehouses'
            let searchDetails = this.search.warehouse_master
            let payload = {
                ...searchDetails,
                page: this.master.warehouse_master.page,
                rows: this.master.warehouse_master.pagelimit,
            }
            this.makeRequest("POST", url, payload)
            .then(result => {
                this.isMasterListLoading = false
                this.master.warehouse_master.list = result.data.data.rows
                this.master.warehouse_master.totalcount = result.data.data.count
                this.master.warehouse_master.pageCount = Math.ceil(result.data.data.count / this.master.pagelimit)
            }).catch(e => {
                this.displayError(e)
            })
        },
        getVehicleRegistrationMaster() {
            // this.getRoutes()
            this.isMasterListLoading = true
            let url = '/master/vehicle_registrations'
            let searchDetails = this.search.vehicle_registration_master
            let payload = {
                ...searchDetails,
                page: this.master.vehicle_registration_master.page,
                rows: this.master.vehicle_registration_master.pagelimit
            }
            this.makeRequest(
                'POST',
                url,
                payload
            ).then(result => {
                this.isMasterListLoading = false
                this.master.vehicle_registration_master.list = result.data.data.rows
                this.master.vehicle_registration_master.totalcount = result.data.data.count
                this.master.vehicle_registration_master.pageCount = Math.ceil(result.data.data.count / this.master.pagelimit)
            }).catch(e => {
                this.displayError(e)
            })
        },
        getRoutes() {
            this.searchNameMasterList('route_details', 'route_path', null, 'route_number')
                .then(result => {
                  this.routeList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        getGateMaster() {
            this.isMasterListLoading = true
            let url = '/master/gates'
            let searchDetails = this.search.gate_master
            let payload = {
                ...searchDetails,
                page: this.master.vehicle_registration_master.page,
                rows: this.master.vehicle_registration_master.pagelimit
            }
            this.makeRequest(
                'POST',
                url,
                payload
            ).then(result => {
                this.isMasterListLoading = false
                this.master.gate_master.list = result.data.data.rows
                this.master.gate_master.totalcount = result.data.data.count
                this.master.gate_master.pageCount = Math.ceil(result.data.data.count / this.master.pagelimit)
            }).catch(e => {
                this.displayError(e)
            })
        },
        getDockMaster() {
            this.isMasterListLoading = true
            let url = '/master/docks'
            let searchDetails = this.search.dock_master
            let payload = {
                ...searchDetails,
                page: this.master.dock_master.page,
                rows: this.master.dock_master.pagelimit
            }
            this.makeRequest(
                'POST',
                url,
                payload
            ).then(result => {
                this.isMasterListLoading = false
                this.master.dock_master.list = result.data.data.rows
                this.master.dock_master.totalcount = result.data.data.count
                this.master.dock_master.pageCount = Math.ceil(result.data.data.count / this.master.pagelimit)
            }).catch(e => {
                this.displayError(e)
            })
        },
        getZoneMaster() {
            this.isMasterListLoading = true
            let url = '/master/zones'
            let searchDetails = this.search.zone_master
            let payload = {
                ...searchDetails,
                page: this.master.zone_master.page,
                rows: this.master.zone_master.pagelimit
            }
            this.makeRequest(
                'POST',
                url,
                payload
            ).then(result => {
                this.isMasterListLoading = false
                this.master.zone_master.list = result.data.data.rows
                this.master.zone_master.totalcount = result.data.data.count
                this.master.zone_master.pageCount = Math.ceil(result.data.data.count / this.master.pagelimit)
            }).catch(e => {
                this.displayError(e)
            })
        },
        getVendorMaster() {
            this.isMasterListLoading = true
            let url = '/master/vendors'
            let searchDetails = this.search.vendor_master
            let payload = {
                ...searchDetails,
                page: this.master.vendor_master.page,
                rows: this.master.vendor_master.pagelimit
            }
            this.makeRequest(
                'POST',
                url,
                payload
            ).then(result => {
                this.isMasterListLoading = false
                this.master.vendor_master.list = result.data.data.rows
                this.master.vendor_master.totalcount = result.data.data.count
                this.master.vendor_master.pageCount = Math.ceil(result.data.data.count / this.master.pagelimit)
            }).catch(e => {
                this.displayError(e)
            })
        },
        getZoneToDockMapping() {
            this.isMasterListLoading = true
            let url = '/master/mapping/dock-to-zone'
            let searchDetails = this.search.map_dock_to_sector
            let payload = {
                ...searchDetails,
                page: this.master.map_dock_to_sector.page,
                rows: this.master.map_dock_to_sector.pagelimit
            }
            this.makeRequest(
               'POST',
                url,
                payload
            ).then(result => {
                this.isMasterListLoading = false
                this.master.map_dock_to_sector.list = result.data.data.rows
                this.master.map_dock_to_sector.totalcount = result.data.data.count
                this.master.map_dock_to_sector.pageCount = Math.ceil(result.data.data.count / this.master.pagelimit)
            }).catch(e => {
                this.displayError(e)
            })
        },
        selectstatus() {},
        date() {},
        getVendorList() {
            this.searchNameMasterList('vendor_master', 'vendor_name', null, 'vendor_id')
                .then(result => {
                  this.vendorList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        getWarehouseList() {
            this.searchNameMasterList('warehouse_master', 'warehouse_name', null, 'warehouse_id')
                .then(result => {
                  this.warehouseList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        getGateList() {
            this.searchNameMasterList('gate_master', 'gate_name', null, 'gate_id')
                .then(result => {
                  this.gateList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        getSectorList() {
            this.searchNameMasterList('zone_master', 'zone_name', null, 'zone_id')
                .then(result => {
                  this.zoneList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        getStateList() {
            this.searchNameMasterList('state', 'state_name', null, 'state_name')
                .then(result => {
                  this.stateList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        getCityList() {
            this.searchNameMasterList('state_city_map', 'city_name', null, 'city_name', 'state_name')
                .then(result => {
                  this.cityList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        filterCityListStateWise(state) {
            if(!this.isFormEdit) {
                this.master.forms.warehouse_master.city = null
                this.master.forms.vendor_master.city = null
            }
            this.cityListStateWise = this.cityList.filter(city => city.field === state)
        },
        getDockList() {
            this.searchNameMasterList('dock_master', 'dock_name', null, 'dock_id', 'warehouse_id')
                .then(result => {
                  this.master.forms.map_dock_to_sector.dockList = result.data
                  this.dockList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        getZoneList(dock) {
            this.searchNameMasterList('zone_master', 'zone_name', null, 'zone_id', 'warehouse_id')
                .then(result => {
                  this.master.forms.map_dock_to_sector.zoneList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        filterZoneListDockWise(dock) {
            this.master.forms.map_dock_to_sector.zone_id = null
            let dockForWarehouse = this.master.forms.map_dock_to_sector.dockList.find(i => i.id == dock)
            if(dockForWarehouse) {
                this.master.forms.map_dock_to_sector.filterDockWiseZoneList = this.master.forms.map_dock_to_sector.zoneList.filter(i => i.field == dockForWarehouse.field)
            } else {
                this.master.forms.map_dock_to_sector.filterDockWiseZoneList = []
            }  
        },
        handlePageChange(pageNum, tab) {
            this.master[tab].pageoffset = pageNum
            this.master[tab].currPageNum = pageNum - 1
            if(tab === "warehouse_master") {
                this.getWarehouseMaster()
            } else if(tab === "gate_master") {
                this.getGateMaster()
            } else if(tab === "dock_master") {
                this.getDockMaster()
            } else if(tab === "zone_master") {
                this.getZoneMaster()
            } else if(tab === "map_dock_to_sector") {
                this.getZoneToDockMapping()
            } else if(tab === "vendor_master") {
                this.getVendorMaster()
            } else if(tab === "vehicle_registration_master") {
                this.getVehicleRegistrationMaster()
            }
            setTimeout(() => {
                $('html, body').animate({
                  scrollTop: $(`#${tab}`).offset().top -70
                });
            }, 500);
        },
        
    }
})
</script>
<style scoped>
.alignment{
    margin-left: 20px;
    margin-bottom: 20px;
}
.requiredField {
    margin-left: 2px;
    color: red
}
#overlay-camera {
  position: fixed;
  display: none;
  width: 100%; 
  height: 100%; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,1);
  z-index: 2; 
  cursor: pointer;
}

.overlay-camera {
  position: fixed;
  display: none;
  width: 100%; 
  height: 100%; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,1);
  z-index: 2; 
  cursor: pointer;
}
</style>